/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
// Generated by build-products.mjs – DO NOT EDIT BY HAND.

import posthog from "posthog-js";
import type { DashboardsTab } from "./scenes/dashboard/dashboards/dashboardsLogic";
import type { FileSystemImport } from "~/queries/schema/schema-general";
import type { InboxTabKey } from "../../products/signals/frontend/inbox/types";
import type { LogsSceneActiveTab } from "../../products/logs/frontend/logsSceneLogic";
import type { MessagingNavTabKey } from "../../products/workflows/frontend/messagingTabs";
import type { MetricsSceneActiveTab } from "../../products/metrics/frontend/metricsSceneLogic";
import type { ModelsSceneTab } from "../../products/data_modeling/frontend/modelsSceneLogic";
import type { NodeDetailSceneTab } from "../../products/data_modeling/frontend/nodeDetail/nodeDetailSceneLogic";
import type { Params } from "scenes/sceneTypes";
import type { ProductSetupProbe } from "lib/components/ProductEmptyState/setupProbes";
import type {
  SchemaConfigurationSection,
  SchemaSceneTab,
} from "../../products/data_warehouse/frontend/scenes/SchemaScene/SchemaScene";
import type { SourceSceneTab } from "../../products/data_warehouse/frontend/scenes/SourceScene/SourceScene";
import type { SurveysTabs } from "scenes/surveys/surveysLogic";
import type { TracingSceneTab } from "../../products/tracing/frontend/tracingSceneLogic";
import type { WarehousePropertiesSceneTab } from "../../products/customer_analytics/frontend/scenes/WarehousePropertiesScene/warehousePropertiesSceneLogic";
import type { WorkflowsSceneTab } from "../../products/workflows/frontend/WorkflowsScene";
import { AI_OBSERVABILITY_CLUSTER_URL_PATTERN } from "../../products/ai_observability/frontend/clusters/constants";
import {
  ActionType,
  AnnotationType,
  AnyPropertyFilter,
  DashboardType,
  FileSystemIconColor,
  InsightSceneSource,
  InsightShortId,
  InsightType,
  RecordingUniversalFilters,
  ReplayTabs,
  SavedInsightsTabs,
  UniversalFiltersGroup,
} from "./types";
import { ActivityScope, ExperimentsTabs } from "~/types";
import { AlertType } from "products/alerts/frontend/types";
import {
  DashboardFilter,
  DateRange,
  ExperimentMetric,
  FileSystemIconType,
  HogQLFilters,
  HogQLQuery,
  HogQLVariable,
  MetricsQuery,
  Node,
  NodeKind,
  ProductItemCategory,
  ProductKey,
  TileFilters,
} from "~/queries/schema/schema-general";
import { FEATURE_FLAGS, INSIGHT_VISUAL_ORDER } from "lib/constants";
import { combineUrl } from "kea-router";
import {
  configurationRedirect,
  resolveSettingSlug,
} from "../../products/error_tracking/frontend/settingsRedirects";
import { examples } from "~/queries/examples";
import {
  isBIVisualizationNode,
  isDataTableNode,
  isDataVisualizationNode,
  isHogQLQuery,
} from "~/queries/utils";
import { scorerFiltersFromSearchParams } from "../../products/ai_observability/frontend/scoreDefinitions/scoreDefinitionNavigation";
import { toParams } from "lib/utils/url";
import { urls } from "scenes/urls";

/** This const is auto-generated, as is the whole file */
export const productRoutes: Record<string, [string, string]> = {
  "/data-management/actions": ["Actions", "actions"],
  "/data-management/actions/new": ["NewAction", "actionNew"],
  "/data-management/actions/:id": ["Action", "action"],
  "/data-management/actions/new/": ["NewAction", "actionNew"],
  "/ai-observability/dashboard": ["AIObservability", "aiObservabilityDashboard"],
  "/ai-observability/self-driving": ["AIObservability", "aiObservabilitySelfDriving"],
  "/ai-observability/generations": ["AIObservability", "aiObservabilityGenerations"],
  "/ai-observability/reviews": ["AIObservability", "aiObservabilityReviews"],
  "/ai-observability/traces": ["AIObservability", "aiObservabilityTraces"],
  "/ai-observability/traces/:id": ["AIObservabilityTrace", "aiObservability"],
  "/ai-observability/users": ["AIObservability", "aiObservabilityUsers"],
  "/ai-observability/errors": ["AIObservability", "aiObservabilityErrors"],
  "/ai-observability/tools": ["AIObservability", "aiObservabilityTools"],
  "/ai-observability/sentiment": ["AIObservability", "aiObservabilitySentiment"],
  "/ai-observability/sessions": ["AIObservability", "aiObservabilitySessions"],
  "/ai-observability/sessions/:id": ["AIObservability", "aiObservabilitySessions"],
  "/ai-observability/playground": ["AIObservabilityPlayground", "aiObservabilityPlayground"],
  "/ai-observability/clusters": ["AIObservabilityClusters", "aiObservabilityClusters"],
  "/ai-observability/clusters/:runId": ["AIObservabilityClusters", "aiObservabilityClusters"],
  [AI_OBSERVABILITY_CLUSTER_URL_PATTERN]: ["AIObservabilityCluster", "aiObservabilityCluster"],
  "/ai-evals/datasets": ["AIObservabilityDatasets", "aiObservabilityDatasets"],
  "/ai-evals/datasets/:id": ["AIObservabilityDataset", "aiObservabilityDataset"],
  "/ai-evals/taggers": ["AIObservabilityTags", "aiObservabilityTags"],
  "/ai-evals/taggers/:id": ["AIObservabilityTag", "aiObservabilityTag"],
  "/ai-evals/evaluations": ["AIObservabilityEvaluations", "aiObservabilityEvaluations"],
  "/ai-evals/evaluations/offline/experiments": [
    "AIObservabilityOfflineExperiments",
    "aiObservabilityOfflineEvaluations",
  ],
  "/ai-evals/evaluations/offline/experiments/:experimentId": [
    "AIObservabilityOfflineExperiment",
    "aiObservabilityOfflineEvaluationExperiment",
  ],
  "/ai-evals/evaluations/scorers": ["AIObservabilityScorers", "aiObservabilityScorers"],
  "/ai-evals/evaluations/scorers/:scorerId/offline": [
    "AIObservabilityOfflineScorerHistory",
    "aiObservabilityOfflineScorerHistory",
  ],
  "/ai-evals/evaluations/scorers/:scorerId": ["AIObservabilityScorer", "aiObservabilityScorer"],
  "/ai-evals/evaluations/templates": [
    "AIObservabilityEvaluationTemplates",
    "aiObservabilityEvaluationTemplates",
  ],
  "/ai-evals/evaluations/:id": ["AIObservabilityEvaluation", "aiObservabilityEvaluation"],
  "/prompt-management/prompts": ["AIObservabilityPrompts", "aiObservabilityPrompts"],
  "/prompt-management/prompts/:name": ["AIObservabilityPrompt", "aiObservabilityPrompt"],
  "/alerts": ["Alerts", "alerts"],
  "/platform-alerts": ["PlatformAlerts", "platformAlerts"],
  "/platform-alerts/:id": ["PlatformAlert", "platformAlert"],
  "/debug/precompute": ["PrecomputeDebug", "precomputeDebug"],
  "/data-management/annotations": ["Annotations", "annotations"],
  "/data-management/annotations/:id": ["Annotations", "annotation"],
  "/autoresearch": ["Autoresearch", "autoresearch"],
  "/autoresearch/new": ["AutoresearchNew", "autoresearchNew"],
  "/autoresearch/:id": ["AutoresearchPipeline", "autoresearchPipeline"],
  "/bi": ["BusinessIntelligenceHome", "businessIntelligence"],
  "/bi/new": ["BusinessIntelligence", "businessIntelligenceNew"],
  "/bi/:insightShortId": ["BusinessIntelligence", "businessIntelligenceWorksheet"],
  "/business-knowledge": ["BusinessKnowledge", "businessKnowledge"],
  "/business-knowledge/settings": ["BusinessKnowledgeSettings", "businessKnowledgeSettings"],
  "/business-knowledge/playground": ["BusinessKnowledgePlayground", "businessKnowledgePlayground"],
  "/business-knowledge/playground/:chatId": [
    "BusinessKnowledgePlayground",
    "businessKnowledgePlayground",
  ],
  "/business-knowledge/:id": ["BusinessKnowledgeSource", "businessKnowledgeSource"],
  "/canvases": ["Canvases", "canvases"],
  "/canvases/new": ["CanvasNew", "canvasNew"],
  "/canvases/:id": ["CanvasDetail", "canvasDetail"],
  "/transformations": ["Transformations", "transformations"],
  "/event-filtering": ["EventFiltering", "eventFiltering"],
  "/feature_flags/staff/cohorts": ["CohortsStaffTools", "cohortsStaffTools"],
  "/support/tickets": ["SupportTickets", "supportTickets"],
  "/support/tickets/:ticketId": ["SupportTicketDetail", "supportTicketDetail"],
  "/support/settings": ["SupportSettings", "supportSettings"],
  "/my-tickets": ["MyTickets", "myTickets"],
  "/cross-project-dashboards": ["CrossProjectDashboards", "crossProjectDashboards"],
  "/cross-project-dashboards/:id": ["CrossProjectDashboard", "crossProjectDashboard"],
  "/customer_analytics/dashboard": ["CustomerAnalytics", "customerAnalyticsDashboard"],
  "/customer_analytics/accounts": ["CustomerAnalytics", "customerAnalyticsAccounts"],
  "/customer_analytics/accounts/by-external-id/*": [
    "CustomerAnalyticsAccount",
    "customerAnalyticsAccount",
  ],
  "/customer_analytics/accounts/:accountId": [
    "CustomerAnalyticsAccount",
    "customerAnalyticsAccount",
  ],
  "/customer_analytics/accounts/:accountId/:tab": [
    "CustomerAnalyticsAccount",
    "customerAnalyticsAccount",
  ],
  "/customer_analytics/notes": ["CustomerAnalytics", "customerAnalyticsNotes"],
  "/customer_analytics/announcements": ["CustomerAnalytics", "customerAnalyticsAnnouncements"],
  "/customer_analytics/feed": ["CustomerAnalytics", "customerAnalyticsFeed"],
  "/customer_analytics/tasks": ["CustomerAnalytics", "customerAnalyticsTasks"],
  "/customer_analytics/feature-requests": ["CustomerAnalytics", "customerAnalyticsFeatureRequests"],
  "/customer_analytics/feature-requests/:requestId": [
    "CustomerAnalytics",
    "customerAnalyticsFeatureRequests",
  ],
  "/customer_analytics/journeys/new": ["CustomerJourneyBuilder", "customerJourneyBuilder"],
  "/customer_analytics/journeys/templates": [
    "CustomerJourneyTemplates",
    "customerJourneyTemplates",
  ],
  "/customer_analytics/journeys/:id/edit": ["CustomerJourneyBuilder", "customerJourneyEdit"],
  "/customer_analytics/journeys": ["CustomerAnalytics", "customerAnalyticsJourneys"],
  "/customer_analytics/configuration": [
    "CustomerAnalyticsConfiguration",
    "customerAnalyticsConfiguration",
  ],
  "/data-management/warehouse-properties": ["WarehouseProperties", "warehouseProperties"],
  "/data-management/warehouse-properties/:tab": ["WarehouseProperties", "warehouseProperties"],
  "/data-catalog": ["DataCatalog", "dataCatalog"],
  "/data-catalog/metrics/:name": ["DataCatalogMetric", "dataCatalogMetric"],
  "/models": ["Models", "models"],
  "/models/:id": ["NodeDetail", "nodeDetail"],
  "/models/:id/:tab": ["NodeDetail", "nodeDetail"],
  "/data-ops": ["DataOps", "dataOps"],
  "/data-management/sources": ["Sources", "sources"],
  "/data-management/sources/:sourceId/schemas/:schemaId": [
    "DataWarehouseSourceSchema",
    "dataWarehouseSourceSchema",
  ],
  "/data-management/sources/:sourceId/schemas/:schemaId/:tab": [
    "DataWarehouseSourceSchema",
    "dataWarehouseSourceSchema",
  ],
  "/data-management/sources/:sourceId/schemas/:schemaId/configuration/:section": [
    "DataWarehouseSourceSchema",
    "dataWarehouseSourceSchema",
  ],
  "/data-management/warehouse-destinations": ["WarehouseDestinations", "warehouseDestinations"],
  "/data-management/sources/:id/:tab": ["DataWarehouseSource", "dataWarehouseSource"],
  "/data-warehouse/new-source": ["DataWarehouseSourceNew", "dataWarehouseSourceNew"],
  "/data-warehouse/connect": ["DataWarehouseSourceConnect", "dataWarehouseSourceConnect"],
  "/early_access_features": ["EarlyAccessFeatures", "earlyAccessFeatures"],
  "/early_access_features/:id": ["EarlyAccessFeature", "earlyAccessFeature"],
  "/endpoints": ["EndpointsScene", "endpoints"],
  "/endpoints/:name": ["EndpointScene", "endpoint"],
  "/engineering-analytics/overview": ["EngineeringAnalytics", "engineeringAnalytics"],
  "/engineering-analytics/pull-requests": [
    "EngineeringAnalytics",
    "engineeringAnalyticsPullRequestList",
  ],
  "/engineering-analytics/workflows": ["EngineeringAnalytics", "engineeringAnalyticsWorkflows"],
  "/engineering-analytics/tests": ["EngineeringAnalytics", "engineeringAnalyticsTests"],
  "/engineering-analytics/teams": ["EngineeringAnalytics", "engineeringAnalyticsTeams"],
  "/engineering-analytics/authors": ["EngineeringAnalytics", "engineeringAnalyticsAuthors"],
  "/engineering-analytics/deploys": ["EngineeringAnalytics", "engineeringAnalyticsDeploys"],
  "/engineering-analytics/teams/:ownerTeam": [
    "EngineeringAnalyticsTeam",
    "engineeringAnalyticsTeam",
  ],
  "/engineering-analytics/repos/:repoOwner/:repoName/pull-requests/:number": [
    "EngineeringAnalyticsPullRequest",
    "engineeringAnalyticsPullRequest",
  ],
  "/engineering-analytics/repos/:repoOwner/:repoName/pull-requests/:number/ci-explorer": [
    "EngineeringAnalyticsCIExplorer",
    "engineeringAnalyticsCIExplorer",
  ],
  "/engineering-analytics/repos/:repoOwner/:repoName/actions/runs/:runId": [
    "EngineeringAnalyticsWorkflowRun",
    "engineeringAnalyticsWorkflowRun",
  ],
  "/engineering-analytics/repos/:repoOwner/:repoName/actions/workflows/:workflowName": [
    "EngineeringAnalyticsWorkflowRuns",
    "engineeringAnalyticsWorkflowRuns",
  ],
  "/engineering-analytics/authors/:handle": [
    "EngineeringAnalyticsAuthor",
    "engineeringAnalyticsAuthor",
  ],
  "/error_tracking": ["ErrorTracking", "errorTracking"],
  "/error_tracking/fingerprint/*": ["ErrorTrackingFingerprint", "errorTrackingFingerprint"],
  "/error_tracking/alerts/new/:templateId": ["HogFunction", "errorTrackingAlertNew"],
  "/error_tracking/alerts/:id": ["HogFunction", "errorTrackingAlert"],
  "/error_tracking/:id": ["ErrorTrackingIssue", "errorTrackingIssue"],
  "/experiments": ["Experiments", "experiments"],
  "/experiments/staff": ["ExperimentsStaffTools", "experimentsStaffTools"],
  "/feature_flags/templates": ["FeatureFlagTemplates", "featureFlagTemplates"],
  "/feature_flags/staff": ["FeatureFlagsStaffTools", "featureFlagsStaffTools"],
  "/games/368hedgehogs": ["Game368Hedgehogs", "game368Hedgehogs"],
  "/games/flappyhog": ["FlappyHog", "flappyHog"],
  "/games/shipit": ["ShipIt", "shipIt"],
  "/groups/:groupTypeIndex": ["Groups", "groups"],
  "/groups/:groupTypeIndex/new": ["GroupsNew", "groupsNew"],
  "/groups/:groupTypeIndex/:groupKey": ["Group", "group"],
  "/groups/:groupTypeIndex/:groupKey/:groupTab": ["Group", "groupWithTab"],
  "/identity-matching": ["IdentityMatching", "identityMatching"],
  "/ai-enrichment": ["AIEnrichment", "aiEnrichment"],
  "/ai-enrichment/:label": ["AIEnrichment", "aiEnrichment"],
  "/legal": ["LegalDocuments", "legalDocuments"],
  "/legal/new/:type": ["LegalDocumentNew", "legalDocumentNew"],
  "/logs": ["Logs", "logs"],
  "/logs/alerts/:id": ["LogsAlertDetail", "logsAlertDetail"],
  "/logs/alerts/:id/notifications/:hogFunctionId": [
    "LogsAlertNotificationDetail",
    "logsAlertNotificationDetail",
  ],
  "/logs/drop-rules/new": ["LogsSamplingNew", "logsSamplingNew"],
  "/logs/drop-rules/:id": ["LogsSamplingDetail", "logsSamplingDetail"],
  "/logs/retention-rules/new": ["LogsRetentionNew", "logsRetentionNew"],
  "/logs/retention-rules/:id": ["LogsRetentionDetail", "logsRetentionDetail"],
  "/managed_migrations": ["ManagedMigration", "managedMigration"],
  "/managed_migrations/new": ["ManagedMigration", "managedMigration"],
  "/mcp-analytics/activity": ["MCPAnalytics", "mcpAnalyticsActivity"],
  "/mcp-analytics/dashboard": ["MCPAnalytics", "mcpAnalyticsDashboard"],
  "/mcp-analytics/sessions": ["MCPAnalytics", "mcpAnalyticsSessions"],
  "/mcp-analytics/tool-quality": ["MCPAnalytics", "mcpAnalyticsToolQuality"],
  "/mcp-analytics/tool-quality/:toolName": ["MCPAnalyticsToolDetail", "mcpAnalyticsTool"],
  "/mcp-analytics/intent-clustering": ["MCPAnalytics", "mcpAnalyticsIntentClustering"],
  "/mcp-analytics/missing-capabilities": ["MCPAnalytics", "mcpAnalyticsMissingCapabilities"],
  "/mcp-analytics/notifications": ["MCPAnalytics", "mcpAnalyticsNotifications"],
  "/mcp-registry": ["MCPRegistry", "mcpRegistry"],
  "/mcp-servers/server/:id": ["McpGatewayServer", "mcpGatewayServer"],
  "/mcp-servers/agent/:id": ["McpGatewayAgent", "mcpGatewayAgent"],
  "/mcp-servers/member/:id": ["McpGatewayMember", "mcpGatewayMember"],
  "/mcp-servers": ["McpGateway", "mcpGateway"],
  "/mcp-servers/:tab": ["McpGateway", "mcpGatewayTab"],
  "/metrics": ["Metrics", "metrics"],
  "/metrics/dashboard-review": ["MetricsDashboardReview", "metricsDashboardReview"],
  "/metrics/dashboard-review/:templateId": ["MetricsDashboardReview", "metricsDashboardReview"],
  "/ml-inference/playground": ["DecisionPlayground", "decisionPlayground"],
  "/notebooks/widgets/:widgetId": ["ReusableWidget", "reusableWidget"],
  "/person/*": ["Person", "personByDistinctId"],
  "/persons/*": ["Person", "personByUUID"],
  "/persons": ["Persons", "persons"],
  "/tasks": ["TaskTracker", "taskTracker"],
  "/tasks/:taskId": ["TaskTracker", "taskDetail"],
  "/pulse": ["Pulse", "pulse"],
  "/replay-vision": ["ReplayVision", "replayVision"],
  "/replay-vision/observations/:observationId": [
    "ReplayVisionObservation",
    "replayVisionObservation",
  ],
  "/replay-vision/:id/template": ["ReplayVisionScannerEditor", "replayVisionScannerTemplate"],
  "/replay-vision/:id/overview": ["ReplayVisionScannerEditor", "replayVisionScannerOverview"],
  "/replay-vision/:id/details": ["ReplayVisionScannerEditor", "replayVisionScannerDetails"],
  "/replay-vision/:id/configure": ["ReplayVisionScannerEditor", "replayVisionScannerConfigure"],
  "/replay-vision/:id/triggers": ["ReplayVisionScannerEditor", "replayVisionScannerTriggers"],
  "/replay-vision/:id/budget": ["ReplayVisionScannerEditor", "replayVisionScannerBudget"],
  "/replay-vision/:id": ["ReplayVisionScanner", "replayVision"],
  "/code-review": ["CodeReview", "codeReview"],
  "/inbox": ["Inbox", "inbox"],
  "/inbox/scout-trials": ["ScoutTrials", "scoutTrials"],
  "/inbox/:tab": ["Inbox", "inbox"],
  "/inbox/scouts/scratchpad": ["Inbox", "inbox"],
  "/inbox/scouts/findings": ["Inbox", "inbox"],
  "/inbox/scouts/runs": ["Inbox", "inbox"],
  "/inbox/reports/triage": ["Inbox", "inbox"],
  "/inbox/scouts/:skillName": ["Inbox", "inbox"],
  "/inbox/scouts/:skillName/:findingId": ["Inbox", "inbox"],
  "/inbox/:tab/:reportId": ["Inbox", "inbox"],
  "/skills": ["Skills", "skills"],
  "/skills/scouts": ["Skills", "skillsScouts"],
  "/skills/review-hog": ["Skills", "skillsReviewHog"],
  "/skills/community": ["CommunitySkills", "communitySkills"],
  "/skills/:name": ["Skill", "skill"],
  "/stamphog": ["Stamphog", "stamphog"],
  "/stamphog/runs": ["StamphogRuns", "stamphogRuns"],
  "/stamphog/digests": ["StamphogDigests", "stamphogDigests"],
  "/stamphog/install/callback": ["Stamphog", "stamphogCallback"],
  "/streamlit-apps": ["StreamlitApps", "streamlitApps"],
  "/streamlit-apps/new": ["StreamlitAppEdit", "streamlitAppNew"],
  "/streamlit-apps/:id": ["StreamlitApp", "streamlitApp"],
  "/streamlit-apps/:id/edit": ["StreamlitAppEdit", "streamlitAppEdit"],
  "/subscriptions": ["Subscriptions", "subscriptions"],
  "/subscriptions/new": ["Subscriptions", "subscriptionNew"],
  "/subscriptions/:subscriptionId/edit": ["Subscriptions", "subscriptionEdit"],
  "/subscriptions/:subscriptionId": ["Subscription", "subscription"],
  "/slack-task-context": ["SlackTaskContext", "slackTaskContext"],
  "/spaces": ["TaskSpaces", "taskSpaces"],
  "/spaces/new": ["TaskNewSession", "taskNewSession"],
  "/spaces/:id": ["TaskSpace", "taskSpace"],
  "/spaces/:id/canvases": ["TaskSpace", "taskSpaceCanvases"],
  "/spaces/:id/new": ["TaskNewSession", "taskSpaceNewSession"],
  "/spaces/:id/settings": ["TaskSpace", "taskSpaceSettings"],
  "/tracing": ["Tracing", "tracing"],
  "/tracing/operation": ["TracingOperation", "tracingOperation"],
  "/tracing/retention-rules/new": ["TracingRetentionNew", "tracingRetentionNew"],
  "/tracing/retention-rules/:id": ["TracingRetentionDetail", "tracingRetentionDetail"],
  "/visual-review": ["VisualReviewIndex", "visualReviewIndex"],
  "/visual-review/settings": ["VisualReviewSettings", "visualReviewSettings"],
  "/visual-review/repos/:repoOwner/:repoName/runs": ["VisualReviewRuns", "visualReviewRepoRuns"],
  "/visual-review/repos/:repoOwner/:repoName/runs/:runId": ["VisualReviewRun", "visualReviewRun"],
  "/visual-review/repos/:repoOwner/:repoName/snapshots": [
    "VisualReviewSnapshotOverview",
    "visualReviewSnapshotOverview",
  ],
  "/visual-review/repos/:repoOwner/:repoName/flakiness": [
    "VisualReviewFlakiness",
    "visualReviewFlakiness",
  ],
  "/visual-review/repos/:repoOwner/:repoName/:runType/snapshots/:identifier": [
    "VisualReviewSnapshotHistory",
    "visualReviewSnapshotHistory",
  ],
  "/visual-review/runs/:runId": ["VisualReviewIndex", "visualReviewLegacyRun"],
  "/visual-review/repos/:repoId/runs": ["VisualReviewIndex", "visualReviewLegacyRepoRuns"],
  "/visual-review/repos/:repoId/snapshots": [
    "VisualReviewIndex",
    "visualReviewLegacySnapshotOverview",
  ],
  "/visual-review/repos/:repoId/flakiness": ["VisualReviewIndex", "visualReviewLegacyFlakiness"],
  "/visual-review/repos/:repoId/:runType/snapshots/:identifier": [
    "VisualReviewIndex",
    "visualReviewLegacySnapshotHistory",
  ],
  "/etl": ["PipelineOverview", "pipelineOverview"],
  "/web/content-autopilot": ["WebAnalytics", "webAnalyticsContentAutopilot"],
  "/heatmaps": ["Heatmaps", "heatmaps"],
  "/heatmaps/new": ["HeatmapNew", "heatmapNew"],
  "/heatmaps/recording": ["HeatmapRecording", "heatmapRecording"],
  "/heatmaps/:id": ["Heatmap", "heatmap"],
  "/wizard/runs": ["WizardRuns", "wizardRuns"],
  "/workflows": ["Workflows", "workflows"],
  "/workflows/:tab": ["Workflows", "workflows"],
  "/workflows/:id/:tab": ["Workflow", "workflowTab"],
  "/workflows/library/templates/:id": ["WorkflowsLibraryTemplate", "workflowsLibraryTemplate"],
  "/workflows/library/templates/new": ["WorkflowsLibraryTemplate", "workflowsLibraryTemplate"],
  "/workflows/library/templates/new?messageId=:messageId": [
    "WorkflowsLibraryTemplate",
    "workflowsLibraryTemplateFromMessage",
  ],
  "/broadcasts": ["Broadcasts", "broadcasts"],
  "/broadcasts/library": ["Broadcasts", "broadcasts"],
  "/broadcasts/channels": ["Broadcasts", "broadcasts"],
  "/broadcasts/opt-outs": ["Broadcasts", "broadcasts"],
  "/broadcasts/suppression": ["Broadcasts", "broadcasts"],
  "/broadcasts/reputation": ["Broadcasts", "broadcasts"],
  "/broadcasts/new": ["Broadcast", "broadcast"],
  "/broadcasts/:id": ["Broadcast", "broadcast"],
};

/** This const is auto-generated, as is the whole file */
export const productRedirects: Record<
  string,
  string | ((params: Params, searchParams: Params, hashParams: Params) => string)
> = {
  "/ai-observability": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/ai-observability/settings": (_params, searchParams, hashParams) => {
    const nextHashParams = { ...hashParams };
    if (Object.prototype.hasOwnProperty.call(nextHashParams, "llm-analytics-byok")) {
      delete nextHashParams["llm-analytics-byok"];
    }
    if (nextHashParams.setting === "llm-analytics-byok") {
      nextHashParams.setting = "ai-observability-byok";
    }
    if (nextHashParams.selectedSetting === "llm-analytics-byok") {
      nextHashParams.selectedSetting = "ai-observability-byok";
    }
    nextHashParams["ai-observability-byok"] = null;
    return combineUrl(urls.settings("project-ai-observability"), searchParams, nextHashParams).url;
  },
  "/ai-evals": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityEvaluations(), searchParams, hashParams).url,
  "/ai-evals/evaluations/offline": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityOfflineEvaluations(), searchParams, hashParams).url,
  "/ai-evals/tags": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTags(), searchParams, hashParams).url,
  "/ai-evals/tags/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTag(params.id), searchParams, hashParams).url,
  "/prompt-management": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPrompts(), searchParams, hashParams).url,
  "/llm-analytics": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/llm-analytics/settings": (_params, searchParams, hashParams) => {
    const nextHashParams = { ...hashParams };
    if (Object.prototype.hasOwnProperty.call(nextHashParams, "llm-analytics-byok")) {
      delete nextHashParams["llm-analytics-byok"];
    }
    if (nextHashParams.setting === "llm-analytics-byok") {
      nextHashParams.setting = "ai-observability-byok";
    }
    if (nextHashParams.selectedSetting === "llm-analytics-byok") {
      nextHashParams.selectedSetting = "ai-observability-byok";
    }
    nextHashParams["ai-observability-byok"] = null;
    return combineUrl(urls.settings("project-ai-observability"), searchParams, nextHashParams).url;
  },
  "/llm-analytics/dashboard": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/llm-analytics/generations": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityGenerations(), searchParams, hashParams).url,
  "/llm-analytics/reviews": (_params, searchParams, hashParams) =>
    searchParams.human_reviews_tab === "scorers"
      ? combineUrl(urls.aiObservabilityScorers(), scorerFiltersFromSearchParams(searchParams)).url
      : combineUrl(urls.aiObservabilityReviews(), searchParams, hashParams).url,
  "/llm-analytics/traces": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTraces(), searchParams, hashParams).url,
  "/llm-analytics/traces/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTrace(params.id), searchParams, hashParams).url,
  "/llm-analytics/users": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityUsers(), searchParams, hashParams).url,
  "/llm-analytics/errors": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityErrors(), searchParams, hashParams).url,
  "/llm-analytics/tools": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTools(), searchParams, hashParams).url,
  "/llm-analytics/sentiment": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilitySentiment(), searchParams, hashParams).url,
  "/llm-analytics/sessions": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilitySessions(), searchParams, hashParams).url,
  "/llm-analytics/sessions/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilitySession(params.id), searchParams, hashParams).url,
  "/llm-analytics/playground": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPlayground(), searchParams, hashParams).url,
  "/llm-analytics/clusters": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityClusters(), searchParams, hashParams).url,
  "/llm-analytics/clusters/:runId": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityClusters(params.runId), searchParams, hashParams).url,
  "/llm-analytics/clusters/:runId/:clusterId": (params, searchParams, hashParams) =>
    combineUrl(
      urls.aiObservabilityCluster(params.runId, params.clusterId),
      searchParams,
      hashParams,
    ).url,
  "/llm-analytics/datasets": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDatasets(), searchParams, hashParams).url,
  "/llm-analytics/datasets/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDataset(params.id), searchParams, hashParams).url,
  "/llm-analytics/tags": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTags(), searchParams, hashParams).url,
  "/llm-analytics/tags/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTag(params.id), searchParams, hashParams).url,
  "/llm-analytics/evaluations": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityEvaluations(), searchParams, hashParams).url,
  "/llm-analytics/evaluations/offline": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityOfflineEvaluations(), searchParams, hashParams).url,
  "/llm-analytics/evaluations/offline/experiments": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityOfflineEvaluations(), searchParams, hashParams).url,
  "/llm-analytics/evaluations/offline/experiments/:experimentId": (
    params,
    searchParams,
    hashParams,
  ) =>
    combineUrl(
      urls.aiObservabilityOfflineEvaluationExperiment(params.experimentId),
      searchParams,
      hashParams,
    ).url,
  "/llm-analytics/evaluations/templates": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityEvaluationTemplates(), searchParams, hashParams).url,
  "/llm-analytics/evaluations/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityEvaluation(params.id), searchParams, hashParams).url,
  "/llm-analytics/prompts": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPrompts(), searchParams, hashParams).url,
  "/llm-analytics/prompts/:name": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPrompt(params.name), searchParams, hashParams).url,
  "/llm-observability": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/llm-observability/dashboard": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/llm-observability/generations": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityGenerations(), searchParams, hashParams).url,
  "/llm-observability/reviews": (_params, searchParams, hashParams) =>
    searchParams.human_reviews_tab === "scorers"
      ? combineUrl(urls.aiObservabilityScorers(), scorerFiltersFromSearchParams(searchParams)).url
      : combineUrl(urls.aiObservabilityReviews(), searchParams, hashParams).url,
  "/llm-observability/traces": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTraces(), searchParams, hashParams).url,
  "/llm-observability/traces/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTrace(params.id), searchParams, hashParams).url,
  "/llm-observability/users": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityUsers(), searchParams, hashParams).url,
  "/llm-observability/playground": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPlayground(), searchParams, hashParams).url,
  "/support": "/support/tickets",
  "/customer_analytics": (_params, searchParams, hashParams) => {
    const defaultTab = posthog.getFeatureFlag(FEATURE_FLAGS.CUSTOMER_ANALYTICS_CSP)
      ? "/customer_analytics/accounts"
      : "/customer_analytics/dashboard";
    return combineUrl(defaultTab, searchParams, hashParams).url;
  },
  "/data-warehouse": () => urls.sources(),
  "/data-warehouse/new": () => urls.dataWarehouseSourceNew(),
  "/data-warehouse/sources": () => urls.sources(),
  "/data-warehouse/sources/:id": ({ id }) => urls.dataWarehouseSource(id, "schemas"),
  "/data-warehouse/sources/:id/:tab": ({ id, tab }) =>
    urls.dataWarehouseSource(id, tab as SourceSceneTab),
  "/data-management/sources/:id": ({ id }) => urls.dataWarehouseSource(id, "schemas"),
  "/engineering-analytics": (_params, searchParams, hashParams): string =>
    combineUrl(urls.engineeringAnalytics(), searchParams, hashParams).url,
  "/engineering-analytics/test-health": (_params, searchParams, hashParams): string =>
    combineUrl(urls.engineeringAnalyticsTests(), searchParams, hashParams).url,
  "/engineering-analytics/health": (_params, searchParams, hashParams): string =>
    combineUrl(urls.engineeringAnalyticsDeploys(), searchParams, hashParams).url,
  "/error_tracking/:id/fingerprints": (params) =>
    combineUrl(`/error_tracking/${params.id}`, { manageFingerprints: "true" }).url,
  "/error_tracking/configuration": (_params, searchParams, hashParams) =>
    configurationRedirect(resolveSettingSlug(searchParams.tab), searchParams, hashParams),
  "/error_tracking/configuration/:tab": (params, searchParams, hashParams) =>
    configurationRedirect(resolveSettingSlug(params.tab), searchParams, hashParams),
  "/error_tracking/settings": (_params, searchParams, hashParams) =>
    configurationRedirect(resolveSettingSlug(searchParams.tab), searchParams, hashParams),
  "/error_tracking/settings/:tab": (params, searchParams, hashParams) =>
    configurationRedirect(resolveSettingSlug(params.tab), searchParams, hashParams),
  "/error_tracking/symbol_sets": (_params, searchParams, hashParams) =>
    configurationRedirect("error-tracking-symbol-sets", searchParams, hashParams),
  "/error_tracking/symbol-sets": (_params, searchParams, hashParams) =>
    configurationRedirect("error-tracking-symbol-sets", searchParams, hashParams),
  "/logs/sampling/new": (_params, searchParams, hashParams) =>
    combineUrl("/logs/drop-rules/new", searchParams, hashParams).url,
  "/logs/sampling/:id": (params, searchParams, hashParams) =>
    combineUrl(`/logs/drop-rules/${params.id}`, searchParams, hashParams).url,
  "/mcp-analytics": (_params, searchParams, hashParams) =>
    combineUrl(urls.mcpAnalyticsDashboard(), { ...searchParams, landing: "auto" }, hashParams).url,
  "/ml-inference/decisions": "/ml-inference/playground",
  "/replay/vision": "/replay-vision",
  "/scout-trials": (_params, searchParams, hashParams) =>
    combineUrl("/inbox/scout-trials", searchParams, hashParams).url,
  "/community-skills": (_params, searchParams, hashParams) =>
    combineUrl(urls.communitySkills(), searchParams, hashParams).url,
  "/prompt-management/skills": (_params, searchParams, hashParams) =>
    combineUrl(urls.skills(), searchParams, hashParams).url,
  "/prompt-management/skills/:name": (params, searchParams, hashParams) =>
    combineUrl(urls.skill(params.name), searchParams, hashParams).url,
  "/llm-analytics/skills": (_params, searchParams, hashParams) =>
    combineUrl(urls.skills(), searchParams, hashParams).url,
  "/llm-analytics/skills/:name": (params, searchParams, hashParams) =>
    combineUrl(urls.skill(params.name), searchParams, hashParams).url,
  "/visual_review": (_params, searchParams, hashParams): string =>
    combineUrl(urls.visualReviewRuns(), searchParams, hashParams).url,
  "/visual_review/*": ({ _ }, searchParams, hashParams): string =>
    combineUrl(`/visual-review/${_}`, searchParams, hashParams).url,
};

/** This const is auto-generated, as is the whole file */
export const productConfiguration: Record<string, any> = {
  Actions: {
    name: "Actions",
    projectBased: true,
    activityScope: "Action",
    description:
      "Combine several related events into one, which you can then analyze in insights and dashboards as if it were a single event.",
    iconType: "action",
  },
  Action: { name: "Action", projectBased: true, activityScope: "Action", iconType: "action" },
  NewAction: {
    name: "New Action",
    projectBased: true,
    activityScope: "Action",
    iconType: "action",
  },
  AIObservability: {
    projectBased: true,
    name: "AI observability",
    layout: "app-container",
    description: "Analyze and understand your AI usage and performance.",
    iconType: "llm_analytics",
    docsHref: "https://posthog.com/docs/ai-observability",
  },
  AIObservabilityTrace: {
    projectBased: true,
    name: "AI observability trace",
    layout: "app-container",
  },
  AIObservabilitySession: {
    projectBased: true,
    name: "AI observability session",
    layout: "app-container",
  },
  AIObservabilityUsers: {
    projectBased: true,
    name: "AI observability users",
    layout: "app-container",
  },
  AIObservabilityPlayground: {
    projectBased: true,
    name: "Playground",
    description: "Test and experiment with LLM prompts in a sandbox environment.",
    layout: "app-full-scene-height",
    iconType: "llm_playground",
    docsHref: "https://posthog.com/docs/ai-observability/playground",
  },
  AIObservabilityDatasets: {
    projectBased: true,
    name: "Datasets",
    description: "Manage datasets for testing and evaluation.",
    layout: "app-container",
    iconType: "llm_datasets",
    docsHref: "https://posthog.com/docs/ai-evals/datasets",
  },
  AIObservabilityDataset: {
    projectBased: true,
    name: "Dataset",
    layout: "app-container",
    iconType: "llm_datasets",
  },
  AIObservabilityEvaluations: {
    projectBased: true,
    name: "Evaluations",
    description: "Configure and monitor automated LLM output evaluations.",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_evaluations",
    docsHref: "https://posthog.com/docs/ai-evals",
  },
  AIObservabilityScorers: {
    projectBased: true,
    name: "Scorers",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityScorer: {
    projectBased: true,
    name: "Scorer",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityOfflineExperiments: {
    projectBased: true,
    name: "Offline evals",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityOfflineExperiment: {
    projectBased: true,
    name: "Offline experiment",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityOfflineScorerHistory: {
    projectBased: true,
    name: "Scorer history",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityEvaluation: {
    projectBased: true,
    name: "Evaluation",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityEvaluationTemplates: {
    projectBased: true,
    name: "Evaluation templates",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityTags: {
    projectBased: true,
    name: "Taggers",
    description: "Add custom tags to your AI generations automatically.",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_tags",
    docsHref: "https://posthog.com/docs/ai-evals/taggers",
  },
  AIObservabilityTag: {
    projectBased: true,
    name: "Tagger",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_tags",
  },
  AIObservabilityPrompts: {
    projectBased: true,
    name: "Prompts",
    description: "Track and manage your LLM prompts.",
    layout: "app-container",
    iconType: "llm_prompts",
    docsHref: "https://posthog.com/docs/prompt-management",
  },
  AIObservabilityPrompt: {
    projectBased: true,
    name: "Prompt",
    layout: "app-container",
    iconType: "llm_prompts",
  },
  AIObservabilityClusters: {
    projectBased: true,
    name: "Clusters",
    description: "Discover patterns and clusters in your AI usage.",
    layout: "app-container",
    iconType: "llm_clusters",
    docsHref: "https://posthog.com/docs/ai-observability/clusters",
  },
  AIObservabilityCluster: {
    projectBased: true,
    name: "AI observability cluster",
    layout: "app-container",
    iconType: "llm_clusters",
  },
  Alerts: {
    projectBased: true,
    name: "Alerts",
    iconType: "inbox",
    description: "Monitor insight metrics and get notified when conditions are met.",
  },
  PlatformAlerts: { name: "Platform alerts", projectBased: true, iconType: "inbox" },
  PlatformAlert: { name: "Platform alert", projectBased: true, iconType: "inbox" },
  PrecomputeDebug: {
    projectBased: true,
    name: "Precompute debug",
    description: "Staff-only view of stored precompute hashes, buckets, and TTLs.",
    layout: "app-container",
    iconType: "web_analytics",
  },
  Annotations: {
    name: "Annotations",
    projectBased: true,
    description:
      "Annotations allow you to mark when certain changes happened so you can easily see how they impacted your metrics.",
    iconType: "annotation",
  },
  Autoresearch: {
    name: "Autoresearch",
    projectBased: true,
    description:
      "Automatically find the best model to predict user behavior and score your users on a schedule.",
    iconType: "experiment",
  },
  AutoresearchNew: { name: "New model", projectBased: true },
  AutoresearchPipeline: { name: "Autoresearch model", projectBased: true },
  BusinessIntelligenceHome: {
    name: "Worksheets",
    projectBased: true,
    iconType: "business_intelligence",
  },
  BusinessIntelligence: {
    name: "Business intelligence",
    projectBased: true,
    layout: "app-raw-no-header",
    hideProjectNotice: true,
    description: "Explore data and build charts with a visual worksheet.",
    iconType: "business_intelligence",
  },
  BusinessKnowledge: {
    name: "Business knowledge",
    projectBased: true,
    activityScope: "KnowledgeSource",
    iconType: "business_knowledge",
    description:
      "Upload text, public URLs, or files so PostHog AI can understand your business context, vision, and policies.",
  },
  BusinessKnowledgePlayground: {
    name: "Business knowledge playground",
    projectBased: true,
    iconType: "business_knowledge",
  },
  BusinessKnowledgeSettings: {
    name: "Business knowledge settings",
    projectBased: true,
    iconType: "business_knowledge",
  },
  BusinessKnowledgeSource: {
    name: "Knowledge source",
    projectBased: true,
    activityScope: "KnowledgeSource",
    iconType: "business_knowledge",
  },
  CanvasNew: { name: "New canvas", projectBased: true, layout: "app-raw" },
  Canvases: { name: "Canvases", projectBased: true },
  CanvasDetail: { name: "Canvas", projectBased: true, layout: "app-raw" },
  Transformations: {
    projectBased: true,
    name: "Transformations",
    description:
      "Transformations let you modify, filter, and enrich event data to improve data quality, privacy, and consistency.",
    activityScope: "HogFunction",
    iconType: "data_pipeline",
  },
  EventFiltering: {
    projectBased: true,
    name: "Event ingestion filtering",
    description: "Drop events at ingestion time based on event metadata.",
    iconType: "data_pipeline",
  },
  CohortsStaffTools: { instanceLevel: true, name: "Cohorts staff tools" },
  SupportTickets: {
    name: "Ticket list",
    description:
      "Collect support tickets from an in-app widget, email, or Slack into one inbox, with the product context behind every ticket",
    iconType: "conversations",
    projectBased: true,
    layout: "app-container",
    docsHref: "https://posthog.com/docs/support",
  },
  SupportTicketDetail: { name: "Ticket detail", projectBased: true, layout: "app-container" },
  SupportSettings: { name: "Support settings", projectBased: true, layout: "app-container" },
  MyTickets: { name: "Your tickets", projectBased: true, layout: "app-container" },
  CrossProjectDashboards: {
    name: "Cross-project dashboards",
    organizationBased: true,
    activityScope: "CrossProjectDashboard",
    description: "Put insights from several projects on one page.",
  },
  CrossProjectDashboard: {
    name: "Cross-project dashboard",
    organizationBased: true,
    activityScope: "CrossProjectDashboard",
  },
  CustomerAnalytics: {
    projectBased: true,
    name: "Customer analytics",
    description: "Understand how your customers interact with your product ",
    iconType: "cohort",
    docsHref: "https://posthog.com/docs/customer-analytics",
  },
  CustomerAnalyticsAccount: {
    projectBased: true,
    name: "Account details",
    iconType: "cohort",
    layout: "app-full-scene-height",
  },
  CustomerAnalyticsConfiguration: { projectBased: true, name: "Customer analytics configuration" },
  CustomerJourneyBuilder: { projectBased: true, name: "New journey" },
  CustomerJourneyTemplates: { projectBased: true, name: "New journey" },
  WarehouseProperties: {
    projectBased: true,
    name: "Warehouse properties",
    description: "Add properties to your people and groups from a data warehouse table.",
    iconType: "data_warehouse",
  },
  DataCatalog: {
    projectBased: true,
    name: "Data catalog",
    layout: "app-container",
    iconType: "data_warehouse",
    description:
      "Review and manage governed metrics, certifications, and relationships for your data.",
    docsHref: "https://posthog.com/docs/semantic-layer",
  },
  DataCatalogMetric: { projectBased: true, name: "Metric" },
  Models: {
    name: "Models",
    projectBased: true,
    description:
      "Create and manage views and materialized views for transforming and organizing your data.",
    iconType: "data_modeling",
  },
  NodeDetail: { name: "Model detail", projectBased: true },
  DataOps: {
    name: "Data ops",
    projectBased: true,
    activityScope: "DataWarehouse",
    description: "Manage your organization's shared data warehouse.",
    iconType: "data_warehouse",
    docsHref: "https://posthog.com/docs/data-warehouse",
  },
  SQLEditor: {
    projectBased: true,
    name: "SQL editor",
    layout: "app-raw-no-header",
    hideProjectNotice: true,
    description: "Write and execute SQL queries against your data warehouse",
    docsHref: "https://posthog.com/docs/sql",
  },
  Sources: {
    projectBased: true,
    name: "Sources",
    description:
      "Import data into PostHog from external sources including webhooks, application connectors, and self-managed databases.",
    activityScope: ActivityScope.HOG_FUNCTION,
    iconType: "data_pipeline",
  },
  DataWarehouseSource: { projectBased: true, name: "Data warehouse source" },
  DataWarehouseSourceNew: { projectBased: true, name: "New data warehouse source" },
  DataWarehouseSourceConnect: { projectBased: true, name: "Connect data warehouse source" },
  DataWarehouseSourceSchema: { projectBased: true, name: "Data warehouse schema" },
  WarehouseDestinations: {
    projectBased: true,
    name: "Warehouse destinations",
    description: "Manage where your warehouse sources write the rows they sync.",
    iconType: "data_warehouse",
  },
  EarlyAccessFeatures: {
    name: "Early access features",
    projectBased: true,
    description:
      "Allow your users to individually enable or disable features that are in public beta.",
    iconType: "early_access_feature",
    docsHref: "https://posthog.com/docs/feature-flags/early-access-feature-management",
  },
  EarlyAccessFeature: { name: "Early access feature", projectBased: true },
  EndpointsScene: {
    projectBased: true,
    name: "Endpoints",
    activityScope: "Endpoints",
    layout: "app-container",
    iconType: "endpoints",
    description:
      "Define queries your application will use via the API and monitor their cost and usage.",
    docsHref: "https://posthog.com/docs/endpoints",
  },
  EndpointScene: { projectBased: true, name: "Endpoint", activityScope: "Endpoint" },
  EngineeringAnalytics: {
    projectBased: true,
    name: "Engineering analytics",
    layout: "app-container",
    description:
      "Pull requests, workflows, tests, deploys, and teams across connected GitHub repos.",
    iconType: "health",
  },
  EngineeringAnalyticsPullRequest: {
    projectBased: true,
    name: "Pull request",
    layout: "app-container",
    description: "A single pull request: lifecycle milestones and CI runs on its head commit.",
    iconType: "health",
  },
  EngineeringAnalyticsCIExplorer: {
    projectBased: true,
    name: "CI explorer",
    layout: "app-container",
    description: "A pull request's CI on one zoomable canvas: workflows, jobs, and matrix shards.",
    iconType: "health",
  },
  EngineeringAnalyticsWorkflowRun: {
    projectBased: true,
    name: "Workflow run",
    layout: "app-container",
    description:
      "A single workflow run: status, duration, branch, and the attributed pull request.",
    iconType: "health",
  },
  EngineeringAnalyticsWorkflowRuns: {
    projectBased: true,
    name: "Workflow runs",
    layout: "app-container",
    description: "A single workflow's recent runs across the connected repo.",
    iconType: "health",
  },
  EngineeringAnalyticsAuthor: {
    projectBased: true,
    name: "Author",
    layout: "app-container",
    description:
      "One author's pull requests \u2014 a filtered view for finding work, not a ranking.",
    iconType: "health",
  },
  EngineeringAnalyticsTeam: {
    projectBased: true,
    name: "Team",
    layout: "app-container",
    description: "One owning team's merge timing and the before/after signal on its owned tests.",
    iconType: "health",
  },
  ErrorTracking: {
    projectBased: true,
    name: "Error tracking",
    iconType: "error_tracking",
    description: "Track and analyze your error tracking data to understand and fix issues.",
    docsHref: "https://posthog.com/docs/error-tracking",
  },
  ErrorTrackingIssue: { projectBased: true, name: "Error tracking issue", layout: "app-raw" },
  ErrorTrackingFingerprint: { projectBased: true, name: "Error tracking fingerprint" },
  Experiments: {
    projectBased: true,
    name: "Experiments",
    activityScope: ActivityScope.EXPERIMENT,
    description:
      "Experiments help you test changes to your product to see which changes will lead to optimal results. Automatic statistical calculations let you see if the results are valid or due to chance.",
    iconType: "experiment",
    docsHref: "https://posthog.com/docs/experiments",
  },
  ExperimentsStaffTools: { instanceLevel: true, name: "Experiments staff tools" },
  FeatureFlagTemplates: { projectBased: true, name: "Feature flag templates" },
  FeatureFlagsStaffTools: { instanceLevel: true, name: "Flags staff tools" },
  Game368Hedgehogs: { name: "368Hedgehogs", projectBased: true, activityScope: "Games" },
  FlappyHog: { name: "FlappyHog", projectBased: true, activityScope: "Games" },
  ShipIt: { name: "Ship It", projectBased: true, activityScope: "Games" },
  Group: { name: "People & groups", projectBased: true },
  Groups: { name: "Groups", projectBased: true },
  GroupsNew: { projectBased: true },
  IdentityMatching: {
    name: "Identity matching",
    projectBased: true,
    activityScope: "IdentityMatching",
    description:
      "Review probable links between anonymous visitors and identified persons, recovered from first-party signals.",
    iconType: "persons",
  },
  AIEnrichment: { name: "AI enrichment", instanceLevel: true },
  LegalDocuments: {
    name: "Legal documents",
    organizationBased: true,
    activityScope: "LegalDocument",
    description:
      "Generate a Business Associate Agreement or Data Processing Agreement for your organization.",
  },
  LegalDocumentNew: {
    name: "New legal document",
    organizationBased: true,
    activityScope: "LegalDocument",
  },
  Logs: {
    projectBased: true,
    name: "Logs",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
    iconType: "logs",
    description: "Monitor and analyze your logs to understand and fix issues.",
    docsHref: "https://posthog.com/docs/logs",
  },
  LogsAlertDetail: {
    projectBased: true,
    name: "Alert",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  LogsAlertNotificationDetail: {
    projectBased: true,
    name: "Destination",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  LogsSamplingNew: {
    projectBased: true,
    name: "New drop rule",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  LogsSamplingDetail: {
    projectBased: true,
    name: "Drop rule",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  LogsRetentionNew: {
    projectBased: true,
    name: "New retention rule",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  LogsRetentionDetail: {
    projectBased: true,
    name: "Retention rule",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  ManagedMigration: {
    name: "Managed migrations",
    description:
      "Managed migrations provide an automated way to migrate your historical data into PostHog.",
    projectBased: true,
  },
  ManagedMigrationNew: { name: "Managed migrations", projectBased: true },
  MCPAnalytics: {
    projectBased: true,
    name: "MCP analytics",
    layout: "app-container",
    description:
      "Capture user intent and behaviour patterns to understand what AI users need from your tools.",
    iconType: "mcp_analytics",
    docsHref: "https://posthog.com/docs/mcp-analytics",
  },
  MCPAnalyticsToolDetail: {
    projectBased: true,
    name: "MCP tool",
    layout: "app-container",
    iconType: "mcp_analytics",
  },
  MCPRegistry: {
    name: "MCP registry",
    projectBased: true,
    description:
      "Find an MCP server for a task, ranked by whether it answers and how well it works.",
  },
  McpGateway: {
    projectBased: true,
    name: "MCP servers",
    description:
      "Route every MCP server your team uses through one gateway: shared credentials, per-tool policies, agent identities, and an audit log.",
    layout: "app-container",
    iconType: "tools",
    docsHref: "https://posthog.com/docs/model-context-protocol",
  },
  McpGatewayServer: { projectBased: true, name: "MCP server" },
  McpGatewayAgent: { projectBased: true, name: "MCP agent" },
  McpGatewayMember: { projectBased: true, name: "MCP member access" },
  Metrics: {
    name: "Metrics",
    projectBased: true,
    layout: "app-container",
    activityScope: "Metrics",
    description:
      "Monitor and analyze application metrics to understand system performance and health.",
    iconType: "metrics",
    docsHref: "https://posthog.com/docs/metrics",
  },
  MetricsDashboardReview: {
    name: "Dashboard review",
    projectBased: true,
    layout: "app-container",
    activityScope: "Metrics",
    description: "Review AI-generated metrics dashboards before projects see them.",
    iconType: "metrics",
  },
  DecisionPlayground: {
    projectBased: true,
    name: "Decisions playground",
    description: "Ask the decision model questions about a piece of text.",
    layout: "app-container",
  },
  ReusableWidget: {
    name: "Reusable widget",
    projectBased: true,
    activityScope: "Notebook",
    iconType: "notebook",
  },
  Person: {
    projectBased: true,
    name: "People",
    activityScope: ActivityScope.PERSON,
    iconType: "user",
  },
  Persons: {
    projectBased: true,
    name: "Persons",
    description: "A catalog of all the people behind your events",
    activityScope: ActivityScope.PERSON,
    iconType: "persons",
  },
  TaskTracker: {
    name: "Tasks",
    projectBased: true,
    activityScope: "TaskTracker",
    description:
      "Tasks are work that agents can do for you, like creating a pull request or fixing an issue.",
    iconType: "task",
    layout: "app-full-scene-height",
    docsHref: "https://posthog.com/docs/posthog-desktop/tasks",
  },
  Pulse: {
    name: "Pulse",
    projectBased: true,
    description:
      "Your always-on product manager: spots growth opportunities and shows how to move the numbers that matter.",
    iconType: "activity",
  },
  ReplayVision: {
    name: "Replay vision",
    projectBased: true,
    description:
      "Set up AI scanners that automatically analyze new session recordings as they come in. Each result emits a queryable event.",
    iconType: "replay_vision",
    layout: "app-container",
    docsHref: "https://posthog.com/docs/replay-vision",
  },
  ReplayVisionScanner: {
    name: "Replay vision scanner",
    projectBased: true,
    iconType: "replay_vision",
    layout: "app-container",
  },
  ReplayVisionScannerEditor: {
    name: "Replay vision scanner editor",
    projectBased: true,
    iconType: "replay_vision",
    layout: "app-container",
  },
  ReplayVisionObservation: {
    name: "Replay vision observation",
    projectBased: true,
    iconType: "replay_vision",
    layout: "app-container",
  },
  CodeReview: {
    name: "Code review",
    projectBased: true,
    description: "Automated code reviews of your pull requests, and your review agent settings.",
    iconType: "code_review",
  },
  ScoutTrials: { name: "Scout trials", projectBased: true },
  Inbox: {
    name: "Self-driving inbox",
    projectBased: true,
    description:
      "Actionable reports automatically generated from user session analysis and other signals.",
    docsHref: "https://posthog.com/docs/self-driving/inbox",
  },
  Skills: {
    projectBased: true,
    name: "Skills",
    description: "Manage versioned agent skills that any MCP-connected agent can discover and use.",
    layout: "app-container",
    iconType: "llm_prompts",
    docsHref: "https://posthog.com/docs/skills",
  },
  Skill: { projectBased: true, name: "Skill", layout: "app-container", iconType: "llm_prompts" },
  CommunitySkills: {
    projectBased: true,
    name: "Community skills",
    description: "Discover and install agent skills shared by the PostHog community.",
    layout: "app-container",
    iconType: "llm_prompts",
  },
  Stamphog: {
    projectBased: true,
    name: "Stamphog",
    iconType: "stamphog",
    activityScope: "StamphogRepoConfig",
  },
  StamphogRuns: { projectBased: true, name: "Stamphog runs", iconType: "stamphog" },
  StamphogDigests: { projectBased: true, name: "Stamphog digests", iconType: "stamphog" },
  StreamlitApps: {
    name: "Streamlit apps",
    description: "Build and share custom Python apps that run on your PostHog data.",
    projectBased: true,
  },
  StreamlitApp: { name: "Streamlit app", projectBased: true },
  StreamlitAppEdit: { name: "Edit Streamlit app", projectBased: true },
  Subscriptions: {
    projectBased: true,
    name: "Subscriptions",
    iconType: "inbox",
    description: "View and manage scheduled insight and dashboard subscriptions for this project.",
  },
  Subscription: {
    projectBased: true,
    name: "Subscription",
    iconType: "inbox",
    description: "View subscription details and delivery history for this project.",
  },
  SlackTaskContext: { name: "Slack task context", projectBased: true },
  TaskSpaces: { name: "Spaces", projectBased: true },
  TaskNewSession: { name: "New session", projectBased: true },
  TaskSpace: { name: "Space", projectBased: true },
  Toolbar: {
    name: "Toolbar",
    projectBased: true,
    description: "PostHog toolbar launches PostHog right in your app or website.",
    iconType: "toolbar",
    docsHref: "https://posthog.com/docs/toolbar",
  },
  Tracing: {
    name: "Tracing",
    projectBased: true,
    layout: "app-container",
    activityScope: "Tracing",
    description:
      "Monitor and analyze distributed traces to understand service performance and debug issues.",
    iconType: "tracing",
    docsHref: "https://posthog.com/docs/distributed-tracing",
  },
  TracingOperation: {
    name: "Operation",
    projectBased: true,
    layout: "app-container",
    activityScope: "Tracing",
    description: "Latency distribution and sample traces for a single operation.",
    iconType: "tracing",
  },
  TracingRetentionNew: {
    name: "New retention rule",
    projectBased: true,
    layout: "app-container",
    activityScope: "Tracing",
    iconType: "tracing",
  },
  TracingRetentionDetail: {
    name: "Retention rule",
    projectBased: true,
    layout: "app-container",
    activityScope: "Tracing",
    iconType: "tracing",
  },
  VisualReviewIndex: {
    name: "Visual review",
    description:
      "Catch unintended UI changes by reviewing screenshot diffs from CI, with the approved baselines committed back to your repo.",
    projectBased: true,
    iconType: "visual_review",
  },
  VisualReviewRuns: { name: "Runs", projectBased: true, iconType: "visual_review" },
  VisualReviewRun: { name: "Visual review run", projectBased: true, iconType: "visual_review" },
  VisualReviewSettings: {
    name: "Visual review settings",
    projectBased: true,
    iconType: "visual_review",
  },
  VisualReviewSnapshotHistory: {
    name: "Visual review snapshot history",
    projectBased: true,
    iconType: "visual_review",
  },
  VisualReviewSnapshotOverview: {
    name: "Snapshots",
    projectBased: true,
    iconType: "visual_review",
  },
  VisualReviewFlakiness: { name: "Flakiness", projectBased: true, iconType: "visual_review" },
  PipelineOverview: {
    projectBased: true,
    name: "ELT",
    description:
      "Every source you import from and every destination you write to, with the health of each.",
    iconType: "data_pipeline",
    docsHref: "https://posthog.com/docs/data-warehouse",
  },
  Heatmaps: {
    name: "Heatmaps",
    projectBased: true,
    iconType: "heatmap",
    description: "Heatmaps are a way to visualize user behavior on your website.",
    docsHref: "https://posthog.com/docs/toolbar/heatmaps",
  },
  Heatmap: { name: "Heatmap", projectBased: true, iconType: "heatmap" },
  HeatmapNew: { name: "New heatmap", projectBased: true, iconType: "heatmap" },
  HeatmapRecording: { name: "Heatmap recording", projectBased: true, iconType: "heatmap" },
  WizardRuns: {
    projectBased: true,
    name: "Wizard runs",
    description: "Run the setup agent in the cloud, then review the changes it produces.",
    layout: "app-container",
    iconType: "llm_prompts",
  },
  Workflows: {
    name: "Workflows",
    iconType: "workflows",
    projectBased: true,
    description: "Automate user communication and internal processes",
    docsHref: "https://posthog.com/docs/workflows",
  },
  Workflow: { name: "Workflows", iconType: "workflows", projectBased: true },
  WorkflowsLibraryTemplate: { name: "Workflows", iconType: "workflows", projectBased: true },
  Broadcasts: {
    name: "Broadcasts",
    iconType: "broadcasts",
    projectBased: true,
    description: "Send a one-time or scheduled email to a group of people",
  },
  Broadcast: {
    name: "Broadcasts",
    iconType: "broadcasts",
    projectBased: true,
    description: "Send a one-time or scheduled email to a group of people",
  },
};

/** This const is auto-generated, as is the whole file */
export const productUrls = {
  createAction: (): string => `/data-management/actions/new`,
  duplicateAction: (action: ActionType | null): string => {
    const queryParams = action ? `?copy=${encodeURIComponent(JSON.stringify(action))}` : "";
    return `/data-management/actions/new/${queryParams}`;
  },
  action: (id: string | number): string => `/data-management/actions/${id}`,
  actions: (): string => "/data-management/actions",
  aiObservabilityDashboard: (): string => "/ai-observability/dashboard",
  aiObservabilitySelfDriving: (): string => "/ai-observability/self-driving",
  aiObservabilityGenerations: (): string => "/ai-observability/generations",
  aiObservabilityReviews: (): string => "/ai-observability/reviews",
  aiObservabilityTraces: (): string => "/ai-observability/traces",
  aiObservabilityTrace: (
    id: string,
    params?: {
      event?: string;
      timestamp?: string;
      exception_ts?: string;
      search?: string;
      tab?: string;
      msg?: string;
      [key: string]: string | undefined;
    },
  ): string => {
    const encodePathSegment = (value: string): string => {
      const encodedValue = encodeURIComponent(value).replace(
        /[!'()*]/g,
        (character) => `%${character.charCodeAt(0).toString(16).toUpperCase()}`,
      );
      return encodeURIComponent(encodedValue).replace(
        /[!'()*]/g,
        (character) => `%${character.charCodeAt(0).toString(16).toUpperCase()}`,
      );
    };
    const definedParams: Record<string, string> = {};
    for (const [key, value] of Object.entries(params ?? {})) {
      if (value !== undefined) {
        definedParams[key] = value;
      }
    }
    const queryParams = new URLSearchParams(definedParams);
    const stringifiedParams = queryParams.toString();
    return `/ai-observability/traces/${encodePathSegment(id)}${stringifiedParams ? `?${stringifiedParams}` : ""}`;
  },
  aiObservabilityUsers: (): string => "/ai-observability/users",
  aiObservabilityErrors: (): string => "/ai-observability/errors",
  aiObservabilityTools: (): string => "/ai-observability/tools",
  aiObservabilitySentiment: (): string => "/ai-observability/sentiment",
  aiObservabilitySessions: (): string => "/ai-observability/sessions",
  aiObservabilitySession: (
    id: string,
    params?: {
      timestamp?: string;
    },
  ): string => {
    const queryParams = new URLSearchParams(params);
    const stringifiedParams = queryParams.toString();
    return `/ai-observability/sessions/${id}${stringifiedParams ? `?${stringifiedParams}` : ""}`;
  },
  aiObservabilityPlayground: (): string => "/ai-observability/playground",
  aiObservabilityDatasets: (): string => "/ai-evals/datasets",
  aiObservabilityDataset: (
    id: string,
    params?: {
      item?: string;
    },
  ): string => combineUrl(`/ai-evals/datasets/${id}`, params).url,
  aiObservabilityTags: (): string => "/ai-evals/taggers",
  aiObservabilityTag: (id: string): string => `/ai-evals/taggers/${id}`,
  aiObservabilityEvaluations: (): string => "/ai-evals/evaluations",
  aiObservabilityScorers: (): string => "/ai-evals/evaluations/scorers",
  aiObservabilityScorer: (
    scorerId: string,
    params?: {
      duplicate?: string;
    },
  ): string =>
    combineUrl(`/ai-evals/evaluations/scorers/${encodeURIComponent(scorerId)}`, params).url,
  aiObservabilityOfflineScorerHistory: (scorerId: string, encode: boolean = true): string =>
    `/ai-evals/evaluations/scorers/${encode ? encodeURIComponent(scorerId) : scorerId}/offline`,
  aiObservabilityOfflineEvaluations: (): string => "/ai-evals/evaluations/offline/experiments",
  aiObservabilityOfflineEvaluationExperiment: (
    experimentId: string,
    encode: boolean = true,
  ): string =>
    `/ai-evals/evaluations/offline/experiments/${encode ? encodeURIComponent(experimentId) : experimentId}`,
  aiObservabilityEvaluationTemplates: (): string => "/ai-evals/evaluations/templates",
  aiObservabilityEvaluation: (id: string): string => `/ai-evals/evaluations/${id}`,
  aiObservabilityPrompts: (): string => "/prompt-management/prompts",
  aiObservabilityPrompt: (name: string): string => `/prompt-management/prompts/${name}`,
  aiObservabilityClusters: (runId?: string): string =>
    runId
      ? `/ai-observability/clusters/${encodeURIComponent(runId)}`
      : "/ai-observability/clusters",
  aiObservabilityCluster: (runId: string, clusterId: number | string): string =>
    `/ai-observability/clusters/${encodeURIComponent(runId)}/${clusterId}`,
  alert: (alertId: string): string => `/alerts?alert_type=insights&alert_id=${alertId}`,
  alerts: (): string => "/alerts",
  platformAlerts: (): string => "/platform-alerts",
  platformAlert: (id: string): string => `/platform-alerts/${id}`,
  precomputeDebug: (): string => `/debug/precompute`,
  annotations: (): string => "/data-management/annotations",
  annotation: (id: AnnotationType["id"] | ":id"): string => `/data-management/annotations/${id}`,
  autoresearch: (): string => "/autoresearch",
  autoresearchNew: (): string => "/autoresearch/new",
  autoresearchPipeline: (id: string): string => `/autoresearch/${id}`,
  businessIntelligenceNew: (): string => "/bi/new",
  businessIntelligenceWorksheet: (insightShortId: string): string =>
    `/bi/${encodeURIComponent(insightShortId)}`,
  businessIntelligence: ({
    insightShortId,
    viewId,
    dashboard,
    filters,
  }: {
    insightShortId?: string;
    viewId?: string;
    dashboard?: number;
    filters?: HogQLFilters;
  } = {}): string => {
    const search = new URLSearchParams();
    if (insightShortId) {
      search.set("open_insight", insightShortId);
    } else if (viewId) {
      search.set("open_view", viewId);
    }
    if (dashboard) {
      search.set("dashboard", String(dashboard));
    }
    const hash = filters ? `#filters=${encodeURIComponent(JSON.stringify(filters))}` : "";
    const query = search.toString();
    return `/bi${query ? `?${query}` : ""}${hash}`;
  },
  businessKnowledge: (): string => "/business-knowledge",
  businessKnowledgeSettings: (): string => "/business-knowledge/settings",
  businessKnowledgePlayground: (chatId?: string): string =>
    chatId ? `/business-knowledge/playground/${chatId}` : "/business-knowledge/playground",
  businessKnowledgeSource: (id: string): string => `/business-knowledge/${id}`,
  canvases: (): string => "/canvases",
  canvasNew: (spaceId?: string | null): string =>
    spaceId ? `/canvases/new?space=${encodeURIComponent(spaceId)}` : "/canvases/new",
  canvasDetail: (id: string): string => `/canvases/${id}`,
  transformations: (): string => "/transformations",
  eventFiltering: (): string => "/event-filtering",
  cohort: (id: string | number): string => `/cohorts/${id}`,
  cohorts: (): string => "/cohorts",
  cohortCalculationHistory: (id: string | number): string => `/cohorts/${id}/calculation-history`,
  cohortsStaffTools: (cohortId?: number): string =>
    `/feature_flags/staff/cohorts${cohortId ? `?cohort_id=${cohortId}` : ""}`,
  supportDashboard: (): string => "/support",
  supportTickets: (): string => "/support/tickets",
  supportTicketDetail: (ticketId: string | number): string => `/support/tickets/${ticketId}`,
  supportSettings: (): string => "/support/settings",
  myTickets: (ticketId?: string): string =>
    ticketId ? `/my-tickets?ticket=${encodeURIComponent(ticketId)}` : "/my-tickets",
  crossProjectDashboards: (): string => "/cross-project-dashboards",
  crossProjectDashboard: (id: string): string => `/cross-project-dashboards/${id}`,
  customerAnalytics: (): string => "/customer_analytics",
  customerAnalyticsDashboard: (): string => "/customer_analytics/dashboard",
  customerAnalyticsAccounts: (): string => "/customer_analytics/accounts",
  customerAnalyticsAccount: (accountId: string, tab?: string): string =>
    `/customer_analytics/accounts/${accountId}${tab ? `/${encodeURIComponent(tab)}` : ""}`,
  customerAnalyticsAccountByExternalId: (externalId: string, tab?: string): string =>
    `/customer_analytics/accounts/by-external-id/${encodeURIComponent(externalId)}${tab ? `/${encodeURIComponent(tab)}` : ""}`,
  customerAnalyticsNotes: (): string => "/customer_analytics/notes",
  customerAnalyticsAnnouncements: (): string => "/customer_analytics/announcements",
  customerAnalyticsFeed: (): string => "/customer_analytics/feed",
  customerAnalyticsTasks: (): string => "/customer_analytics/tasks",
  customerAnalyticsFeatureRequests: (requestId?: string): string =>
    `/customer_analytics/feature-requests${requestId ? `/${requestId}` : ""}`,
  customerAnalyticsJourneys: (): string => "/customer_analytics/journeys",
  customerAnalyticsConfiguration: (tab?: string, returnTo?: string): string =>
    combineUrl("/customer_analytics/configuration", {
      ...(tab ? { tab } : {}),
      ...(returnTo ? { returnTo } : {}),
    }).url,
  customerJourneyBuilder: (): string => "/customer_analytics/journeys/new",
  customerJourneyTemplates: (): string => "/customer_analytics/journeys/templates",
  customerJourneyEdit: (id: string): string => `/customer_analytics/journeys/${id}/edit`,
  warehouseProperties: (tab?: WarehousePropertiesSceneTab): string =>
    `/data-management/warehouse-properties${tab ? `/${tab}` : ""}`,
  dashboards: (tab?: `${DashboardsTab}`): string => (tab ? `/dashboard?tab=${tab}` : "/dashboard"),
  dashboardTemplates: (): string => combineUrl("/dashboard", { templates: "1" }).url,
  dashboard: (id: string | number, highlightInsightId?: string): string =>
    combineUrl(`/dashboard/${id}`, highlightInsightId ? { highlightInsightId } : {}).url,
  dashboardTile: (id: string | number, tileId: string | number): string =>
    `${urls.dashboard(id)}/tiles/${tileId}`,
  dashboardSharing: (id: string | number): string => `/dashboard/${id}/sharing`,
  dashboardSubscriptions: (id: string | number): string => `/dashboard/${id}/subscriptions`,
  dashboardSubscription: (id: string | number, subscriptionId: string): string =>
    `/dashboard/${id}/subscriptions/${subscriptionId}`,
  sharedDashboard: (shareToken: string): string => `/shared_dashboard/${shareToken}`,
  dataCatalog: (tab?: string): string => `/data-catalog${tab ? `?tab=${tab}` : ""}`,
  dataCatalogMetric: (name: string, tab?: "definition" | "data-quality" | "lineage"): string =>
    `/data-catalog/metrics/${name}${tab && tab !== "definition" ? `?tab=${tab}` : ""}`,
  models: (tab?: ModelsSceneTab): string =>
    tab && tab !== "overview" ? `/models?tab=${tab}` : "/models",
  nodeDetail: (id: string, tab?: NodeDetailSceneTab): string =>
    `/models/${id}${tab ? `/${tab}` : ""}`,
  dataOps: (tab?: string): string => {
    const params = new URLSearchParams();
    if (tab) {
      params.set("tab", tab);
    }
    const query = params.toString();
    return query ? `/data-ops?${query}` : "/data-ops";
  },
  sources: (): string => "/data-management/sources",
  dataWarehouseSource: (id: string, tab?: SourceSceneTab): string =>
    `/data-management/sources/${id}/${tab ?? "schemas"}`,
  dataWarehouseSourceSchema: (
    sourceId: string,
    schemaId: string,
    tab?: SchemaSceneTab,
    section?: SchemaConfigurationSection,
  ): string => {
    const base = `/data-management/sources/${sourceId}/schemas/${schemaId}`;
    if (tab === "configuration" && section) {
      return `${base}/configuration/${section}`;
    }
    return tab ? `${base}/${tab}` : base;
  },
  dataWarehouseSourceNew: (
    kind?: string,
    returnUrl?: string,
    returnLabel?: string,
    accessMethod?: "warehouse" | "direct",
    entryPoint?: string,
  ): string => {
    const params = new URLSearchParams();
    if (kind) {
      params.set("kind", kind);
    }
    if (returnUrl) {
      params.set("returnUrl", returnUrl);
    }
    if (returnLabel) {
      params.set("returnLabel", returnLabel);
    }
    if (accessMethod) {
      params.set("access_method", accessMethod);
    }
    if (entryPoint) {
      params.set("entry_point", entryPoint);
    }
    const queryString = params.toString();
    return `/data-warehouse/new-source${queryString ? `?${queryString}` : ""}`;
  },
  warehouseDestinations: (): string => "/data-management/warehouse-destinations",
  warehouseDestination: (id: string): string =>
    `/data-management/warehouse-destinations?destination=${encodeURIComponent(id)}`,
  dataWarehouseSourceConnect: (kind?: string): string =>
    `/data-warehouse/connect${kind ? `?kind=${encodeURIComponent(kind)}` : ""}`,
  earlyAccessFeatures: (): string => "/early_access_features",
  earlyAccessFeature: (id: string): string => `/early_access_features/${id}`,
  endpoints: (): string => "/endpoints",
  endpoint: (name: string, version?: number): string => {
    const searchParams: Record<string, string> = {};
    if (version) {
      searchParams.version = String(version);
    }
    return combineUrl(`/endpoints/${name}`, searchParams).url;
  },
  endpointsUsage: (params?: {
    endpointFilter?: string[];
    dateFrom?: string;
    dateTo?: string;
    materializationType?: "materialized" | "inline";
    interval?: string;
    breakdownBy?: string;
  }): string => {
    if (!params) {
      return "/endpoints?tab=usage";
    }
    const searchParams: Record<string, string> = {};
    if (params.endpointFilter?.length) {
      searchParams.endpointFilter = params.endpointFilter.join(",");
    }
    if (params.dateFrom) {
      searchParams.dateFrom = params.dateFrom;
    }
    if (params.dateTo) {
      searchParams.dateTo = params.dateTo;
    }
    if (params.materializationType) {
      searchParams.materializationType = params.materializationType;
    }
    if (params.interval) {
      searchParams.interval = params.interval;
    }
    if (params.breakdownBy) {
      searchParams.breakdownBy = params.breakdownBy;
    }
    return combineUrl("/endpoints", { tab: "usage", ...searchParams }).url;
  },
  engineeringAnalytics: (): string => "/engineering-analytics/overview",
  engineeringAnalyticsPullRequestList: (): string => "/engineering-analytics/pull-requests",
  engineeringAnalyticsWorkflows: (): string => "/engineering-analytics/workflows",
  engineeringAnalyticsTests: (): string => "/engineering-analytics/tests",
  engineeringAnalyticsTeams: (): string => "/engineering-analytics/teams",
  engineeringAnalyticsAuthors: (): string => "/engineering-analytics/authors",
  engineeringAnalyticsDeploys: (): string => "/engineering-analytics/deploys",
  engineeringAnalyticsTeam: (ownerTeam: string): string =>
    `/engineering-analytics/teams/${encodeURIComponent(ownerTeam)}`,
  engineeringAnalyticsPullRequest: (
    repoOwner: string,
    repoName: string,
    number: number | string,
  ): string =>
    `/engineering-analytics/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/pull-requests/${number}`,
  engineeringAnalyticsCIExplorer: (
    repoOwner: string,
    repoName: string,
    number: number | string,
  ): string =>
    `/engineering-analytics/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/pull-requests/${number}/ci-explorer`,
  engineeringAnalyticsWorkflowRun: (
    repoOwner: string,
    repoName: string,
    runId: number | string,
    ciEngine?: string | null,
  ): string =>
    `/engineering-analytics/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/actions/runs/${runId}${ciEngine ? `?ci_engine=${encodeURIComponent(ciEngine)}` : ""}`,
  engineeringAnalyticsWorkflowRuns: (
    repoOwner: string,
    repoName: string,
    workflowName: string,
  ): string =>
    `/engineering-analytics/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/actions/workflows/${encodeURIComponent(workflowName)}`,
  engineeringAnalyticsAuthor: (handle: string): string =>
    `/engineering-analytics/authors/${encodeURIComponent(handle)}`,
  errorTracking: (params = {}): string => combineUrl("/error_tracking", params).url,
  errorTrackingConfiguration: (params = {}): string =>
    combineUrl("/error_tracking", { ...params, activeTab: "configuration" }).url,
  errorTrackingIssue: (
    id: string,
    params: {
      timestamp?: string;
      fingerprint?: string;
      searchQuery?: string;
      dateRange?: DateRange;
      filterGroup?: UniversalFiltersGroup;
      utm_source?: string;
      utm_campaign?: string;
      utm_medium?: string;
    } = {},
  ): string => combineUrl(`/error_tracking/${id}`, params).url,
  errorTrackingFingerprint: (
    fingerprint: string,
    params: {
      timestamp?: string;
    } = {},
  ): string =>
    combineUrl(`/error_tracking/fingerprint/${encodeURIComponent(fingerprint)}`, params).url,
  errorTrackingAlert: (id: string): string => `/error_tracking/alerts/${id}`,
  errorTrackingAlertNew: (templateId: string): string => `/error_tracking/alerts/new/${templateId}`,
  experiment: (
    id: string | number,
    formMode?: string | null,
    options?: {
      metric?: ExperimentMetric;
      name?: string;
      tab?: string;
    },
  ): string => {
    const baseUrl = formMode ? `/experiments/${id}/${formMode}` : `/experiments/${id}`;
    const params = options ? toParams(options) : "";
    return params ? `${baseUrl}?${params}` : baseUrl;
  },
  experiments: (tab?: ExperimentsTabs): string =>
    tab ? `/experiments?tab=${tab}` : "/experiments",
  experimentsStaffTools: (): string => "/experiments/staff",
  experimentsSharedMetrics: (): string => "/experiments/shared-metrics",
  experimentsSharedMetric: (id: string | number, action?: string): string =>
    action ? `/experiments/shared-metrics/${id}/${action}` : `/experiments/shared-metrics/${id}`,
  featureFlag: (id: string | number): string => `/feature_flags/${id}`,
  featureFlags: (tab?: string): string => `/feature_flags${tab ? `?tab=${tab}` : ""}`,
  featureFlagTemplates: (): string => "/feature_flags/templates",
  featureFlagsStaffTools: (teamId?: number): string =>
    `/feature_flags/staff${teamId ? `?team_id=${teamId}` : ""}`,
  featureFlagNew: ({
    type,
    sourceId,
    template,
    intent,
    format,
    properties,
  }: {
    type?: "boolean" | "multivariate" | "remote_config";
    sourceId?: number | string | null;
    template?: "simple" | "targeted" | "multivariate" | "targeted-multivariate";
    intent?: "local-eval" | "first-page-load";
    format?: "rules_v2";
    properties?: AnyPropertyFilter[];
  }): string => {
    const params = new URLSearchParams();
    if (type) {
      params.set("type", type);
    }
    if (sourceId) {
      params.set("sourceId", sourceId.toString());
    }
    if (template) {
      params.set("template", template);
    }
    if (intent) {
      params.set("intent", intent);
    }
    if (format) {
      params.set("format", format);
    }
    if (properties?.length) {
      params.set("properties", JSON.stringify(properties));
    }
    return `/feature_flags/new?${params.toString()}`;
  },
  game368hedgehogs: (): string => `/games/368hedgehogs`,
  flappyHog: (): string => `/games/flappyhog`,
  shipIt: (): string => `/games/shipit`,
  groups: (groupTypeIndex: string | number): string => `/groups/${groupTypeIndex}`,
  groupsNew: (groupTypeIndex: string | number): string => `/groups/${groupTypeIndex}/new`,
  group: (
    groupTypeIndex: string | number,
    groupKey: string,
    encode: boolean = true,
    tab?: string | null,
  ): string =>
    `/groups/${groupTypeIndex}/${encode ? encodeURIComponent(groupKey) : groupKey}${tab ? `/${tab}` : ""}`,
  identityMatching: (): string => "/identity-matching",
  aiEnrichment: (label?: string): string =>
    `/ai-enrichment${label ? `/${encodeURIComponent(label)}` : ""}`,
  legalDocuments: (): string => "/legal",
  legalDocumentNew: (type: "BAA" | "DPA"): string => `/legal/new/${type.toLowerCase()}`,
  logs: (activeTab?: LogsSceneActiveTab): string =>
    activeTab ? `/logs?activeTab=${activeTab}` : "/logs",
  logsAlertDetail: (id: string, tab?: string): string =>
    tab ? `/logs/alerts/${id}?tab=${tab}` : `/logs/alerts/${id}`,
  logsAlertNotificationDetail: (alertId: string, hogFunctionId: string): string =>
    `/logs/alerts/${alertId}/notifications/${hogFunctionId}`,
  logsSamplingNew: (): string => "/logs/drop-rules/new",
  logsSamplingDetail: (id: string): string => `/logs/drop-rules/${id}`,
  logsRetentionNew: (): string => "/logs/retention-rules/new",
  logsRetentionDetail: (id: string): string => `/logs/retention-rules/${id}`,
  managedMigration: (): string => "/managed_migrations",
  managedMigrationNew: (): string => "/managed_migrations/new",
  marketingAnalyticsApp: (): string => "/marketing",
  mcpAnalytics: (): string => "/mcp-analytics",
  mcpAnalyticsActivity: (): string => "/mcp-analytics/activity",
  mcpAnalyticsDashboard: (): string => "/mcp-analytics/dashboard",
  mcpAnalyticsSessions: (): string => "/mcp-analytics/sessions",
  mcpAnalyticsToolQuality: (): string => "/mcp-analytics/tool-quality",
  mcpAnalyticsTool: (toolName: string): string =>
    `/mcp-analytics/tool-quality/${encodeURIComponent(toolName)}`,
  mcpAnalyticsIntentClustering: (): string => "/mcp-analytics/intent-clustering",
  mcpAnalyticsMissingCapabilities: (): string => "/mcp-analytics/missing-capabilities",
  mcpAnalyticsNotifications: (): string => "/mcp-analytics/notifications",
  mcpRegistry: (): string => "/mcp-registry",
  mcpGateway: (): string => "/mcp-servers",
  mcpGatewayTab: (tab: string): string => `/mcp-servers/${tab}`,
  mcpGatewayServer: (id: string, scope?: string): string =>
    `/mcp-servers/server/${id}${scope ? `?scope=${encodeURIComponent(scope)}` : ""}`,
  mcpGatewayAgent: (id: string): string => `/mcp-servers/agent/${id}`,
  mcpGatewayMember: (id: string | number): string => `/mcp-servers/member/${id}`,
  metrics: (activeTab?: MetricsSceneActiveTab): string =>
    activeTab ? `/metrics?activeTab=${activeTab}` : "/metrics",
  metricsDashboardReview: (templateId?: string): string =>
    templateId ? `/metrics/dashboard-review/${templateId}` : "/metrics/dashboard-review",
  decisionPlayground: (): string => "/ml-inference/playground",
  notebooks: (tab?: "widgets"): string => (tab ? `/notebooks?tab=${tab}` : "/notebooks"),
  notebook: (shortId: string): string => `/notebooks/${shortId}`,
  canvas: (): string => `/canvas`,
  reusableWidget: (widgetId: string): string => `/notebooks/widgets/${widgetId}`,
  personByDistinctId: (id: string, encode: boolean = true): string =>
    encode ? `/person/${encodeURIComponent(id)}` : `/person/${id}`,
  personByUUID: (uuid: string, encode: boolean = true): string =>
    encode ? `/persons/${encodeURIComponent(uuid)}` : `/persons/${uuid}`,
  persons: (): string => "/persons",
  taskTracker: (): string => "/tasks",
  taskDetail: (taskId: string | number): string => `/tasks/${taskId}`,
  taskNew: (): string => "/tasks/new",
  insights: (): string => "/insights",
  insightNew: ({
    type,
    dashboardId,
    query,
    sceneSource,
  }: {
    type?: InsightType;
    dashboardId?: DashboardType["id"] | null;
    query?: Node;
    sceneSource?: InsightSceneSource;
  } = {}): string => {
    if (isBIVisualizationNode(query)) {
      return combineUrl(
        urls.businessIntelligence(),
        dashboardId ? { dashboard: dashboardId } : {},
        { q: JSON.stringify(query) },
      ).url;
    }
    if (isHogQLQuery(query)) {
      return urls.sqlEditor({ query: query.query });
    }
    if ((isDataVisualizationNode(query) || isDataTableNode(query)) && isHogQLQuery(query.source)) {
      return urls.sqlEditor({ query });
    }
    return combineUrl("/insights/new", dashboardId ? { dashboard: dashboardId } : {}, {
      ...(type ? { insight: type } : {}),
      ...(query ? { q: typeof query === "string" ? query : JSON.stringify(query) } : {}),
      ...(sceneSource ? { sceneSource } : {}),
    }).url;
  },
  insightNewHogQL: ({ query, filters }: { query: string; filters?: HogQLFilters }): string =>
    urls.insightNew({
      query: {
        kind: NodeKind.DataTableNode,
        source: { kind: "HogQLQuery", query, filters },
      } as any,
    }),
  insightEdit: (id: InsightShortId, dashboardId?: number): string =>
    `/insights/${id}/edit${dashboardId ? `?dashboard=${dashboardId}` : ""}`,
  insightView: (
    id: InsightShortId,
    dashboardId?: number,
    variablesOverride?: Record<string, HogQLVariable>,
    filtersOverride?: DashboardFilter,
    tileFiltersOverride?: TileFilters,
  ): string => {
    const params = [
      { param: "dashboard", value: dashboardId },
      { param: "variables_override", value: variablesOverride },
      { param: "filters_override", value: filtersOverride },
      { param: "tile_filters_override", value: tileFiltersOverride },
    ]
      .filter((n) => Boolean(n.value))
      .map((n) => `${n.param}=${encodeURIComponent(JSON.stringify(n.value))}`)
      .join("&");
    return `/insights/${id}${params.length ? `?${params}` : ""}`;
  },
  insightSubcriptions: (id: InsightShortId): string => `/insights/${id}/subscriptions`,
  insightSubcription: (id: InsightShortId, subscriptionId: string): string =>
    `/insights/${id}/subscriptions/${subscriptionId}`,
  insightSharing: (id: InsightShortId): string => `/insights/${id}/sharing`,
  savedInsights: (tab?: SavedInsightsTabs): string => `/insights${tab ? `?tab=${tab}` : ""}`,
  insightAlerts: (insightShortId: InsightShortId): string => `/insights/${insightShortId}/alerts`,
  insightAlert: (insightShortId: InsightShortId, alertId: AlertType["id"]): string =>
    `/insights/${insightShortId}/alerts?alert_id=${alertId}`,
  insightQuickStart: (): string => "/insights/quick-start",
  productTours: (): string => "/product_tours",
  productTour: (id: string): string => `/product_tours/${id}`,
  pulse: (): string => "/pulse",
  replay: (
    tab?: ReplayTabs,
    filters?: Partial<RecordingUniversalFilters>,
    sessionRecordingId?: string,
    order?: string,
  ): string =>
    combineUrl(tab ? `/replay/${tab}` : "/replay/home", {
      ...(filters ? { filters } : {}),
      ...(sessionRecordingId ? { sessionRecordingId } : {}),
      ...(order ? { order } : {}),
    }).url,
  replayPlaylist: (id: string): string => `/replay/playlists/${id}`,
  replaySingle: (
    id: string,
    options?: {
      secondsOffsetFromStart?: number;
      unixTimestampMillis?: number;
    },
  ): string => {
    if (options?.unixTimestampMillis) {
      return `/replay/${id}?timestamp=${options.unixTimestampMillis}`;
    }
    if (options?.secondsOffsetFromStart) {
      return `/replay/${id}?t=${options.secondsOffsetFromStart}`;
    }
    return `/replay/${id}`;
  },
  replayFilePlayback: (): string => "/replay/file-playback",
  replayKiosk: (): string => "/replay/kiosk",
  replaySettings: (sectionId?: string): string =>
    `/replay/settings${sectionId ? `?sectionId=${sectionId}` : ""}`,
  replayVision: (id?: string): string => (id ? `/replay-vision/${id}` : "/replay-vision"),
  replayVisionTab: (tab: "search" | "usage"): string => `/replay-vision?tab=${tab}`,
  replayVisionTemplates: (): string => "/replay-vision/new/template",
  replayVisionScannerTemplate: (id: string): string => `/replay-vision/${id}/template`,
  replayVisionScannerOverview: (id: string): string => `/replay-vision/${id}/overview`,
  replayVisionScannerDetails: (id: string): string => `/replay-vision/${id}/details`,
  replayVisionScannerConfigure: (id: string): string => `/replay-vision/${id}/configure`,
  replayVisionScannerTriggers: (id: string): string => `/replay-vision/${id}/triggers`,
  replayVisionScannerBudget: (id: string): string => `/replay-vision/${id}/budget`,
  replayVisionObservation: (observationId: string): string =>
    `/replay-vision/observations/${observationId}`,
  codeReview: (): string => "/code-review",
  inbox: (tab?: InboxTabKey | ":tab"): string => `/inbox${tab ? `/${tab}` : ""}`,
  inboxReport: (tab: InboxTabKey | ":tab", reportId: string | ":reportId"): string =>
    `/inbox/${tab}/${reportId}`,
  inboxTriage: (): string => "/inbox/reports/triage",
  inboxScout: (skillName: string | ":skillName", findingId?: string | ":findingId"): string => {
    const segment = findingId
      ? `/${findingId === ":findingId" ? findingId : encodeURIComponent(findingId)}`
      : "";
    return `/inbox/scouts/${skillName}${segment}`;
  },
  inboxScratchpad: (): string => "/inbox/scouts/scratchpad",
  inboxFindings: (): string => "/inbox/scouts/findings",
  inboxRuns: (): string => "/inbox/scouts/runs",
  inboxScoutTrials: (): string => "/inbox/scout-trials",
  skills: (): string => "/skills",
  skillsCategoryTab: (categoryTab: string): string => `/skills/${categoryTab}`,
  skill: (
    name: string,
    params?: {
      file?: string;
      version?: number;
    },
  ): string => combineUrl(`/skills/${name}`, params).url,
  communitySkills: (): string => "/skills/community",
  stamphog: (): string => "/stamphog",
  stamphogRuns: (): string => "/stamphog/runs",
  stamphogDigests: (): string => "/stamphog/digests",
  stamphogCallback: (): string => "/stamphog/install/callback",
  streamlitApps: (): string => "/streamlit-apps",
  streamlitApp: (id: string): string => `/streamlit-apps/${id}`,
  streamlitAppEdit: (id: string): string => `/streamlit-apps/${id}/edit`,
  streamlitAppNew: (): string => "/streamlit-apps/new",
  subscriptions: (): string => "/subscriptions",
  subscription: (id: string | number): string => `/subscriptions/${id}`,
  subscriptionNew: (): string => "/subscriptions/new",
  subscriptionEdit: (id: string | number): string => `/subscriptions/${id}/edit`,
  surveys: (tab?: `${SurveysTabs}`): string => `/surveys${tab ? `?tab=${tab}` : ""}`,
  survey: (id: string): string => `/surveys/${id}`,
  surveyFormBuilder: (id: string = "new"): string => `/surveys/form/${id}`,
  surveyWizard: (id: string = "new", template?: string): string =>
    `/surveys/guided/${id}${template ? `?template=${encodeURIComponent(template)}` : ""}`,
  slackTaskContext: (): string => "/slack-task-context",
  taskSpaces: (): string => "/spaces",
  taskNewSession: (): string => "/spaces/new",
  taskSpace: (id: string): string => `/spaces/${id}`,
  taskSpaceCanvases: (id: string): string => `/spaces/${id}/canvases`,
  taskSpaceNewSession: (id: string): string => `/spaces/${id}/new`,
  taskSpaceSettings: (id: string): string => `/spaces/${id}/settings`,
  toolbarLaunch: (): string => "/toolbar",
  tracing: (tab?: TracingSceneTab): string => (tab ? `/tracing?tab=${tab}` : "/tracing"),
  tracingOperation: (
    serviceName: string,
    spanName: string,
    dateRange?: {
      date_from?: string | null;
      date_to?: string | null;
    },
  ): string =>
    combineUrl("/tracing/operation", {
      service: serviceName,
      name: spanName,
      ...(dateRange ? { dateRange: JSON.stringify(dateRange) } : {}),
    }).url,
  tracingRetentionNew: (): string => "/tracing/retention-rules/new",
  tracingRetentionDetail: (id: string): string => `/tracing/retention-rules/${id}`,
  visualReviewRuns: (): string => "/visual-review",
  visualReviewSettings: (): string => "/visual-review/settings",
  visualReviewRun: (runId: string): string => `/visual-review/runs/${runId}`,
  visualReviewRepoRun: (repoOwner: string, repoName: string, runId: string): string =>
    `/visual-review/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/runs/${runId}`,
  visualReviewRepoRuns: (repoOwner: string, repoName: string): string =>
    `/visual-review/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/runs`,
  visualReviewSnapshotOverview: (repoOwner: string, repoName: string): string =>
    `/visual-review/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/snapshots`,
  visualReviewFlakiness: (repoOwner: string, repoName: string): string =>
    `/visual-review/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/flakiness`,
  visualReviewSnapshotHistory: (
    repoOwner: string,
    repoName: string,
    runType: string,
    identifier: string,
  ): string =>
    `/visual-review/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/${encodeURIComponent(runType)}/snapshots/${encodeURIComponent(identifier)}`,
  etlOverview: (): string => "/etl",
  webAnalytics: (): string => `/web`,
  webAnalyticsWebVitals: (): string => `/web/web-vitals`,
  webAnalyticsPageReports: (): string => `/web/page-reports`,
  webAnalyticsMarketing: (): string => `/web/marketing`,
  webAnalyticsHealth: (): string => `/web/health`,
  webAnalyticsLive: (): string => `/web/live`,
  webAnalyticsBotAnalytics: (): string => `/web/bot-analytics`,
  webAnalyticsContentAutopilot: (): string => `/web/content-autopilot`,
  heatmaps: (params?: string): string =>
    `/heatmaps${params ? `?${params.startsWith("?") ? params.slice(1) : params}` : ""}`,
  heatmapNew: (params?: string): string =>
    `/heatmaps/new${params ? `?${params.startsWith("?") ? params.slice(1) : params}` : ""}`,
  heatmapRecording: (params?: string): string =>
    `/heatmaps/recording${params ? `?${params.startsWith("?") ? params.slice(1) : params}` : ""}`,
  heatmap: (id: string | number): string => `/heatmaps/${id}`,
  wizardRuns: (): string => "/wizard/runs",
  workflows: (tab?: WorkflowsSceneTab): string => `/workflows${tab ? `/${tab}` : ""}`,
  workflow: (id: string, tab: string): string => `/workflows/${id}/${tab}`,
  workflowNew: (): string => "/workflows/new/workflow",
  workflowsLibraryMessage: (id: string): string => `/workflows/library/messages/${id}`,
  workflowsLibraryTemplate: (id?: string): string => `/workflows/library/templates/${id}`,
  workflowsLibraryTemplateNew: (): string => "/workflows/library/templates/new",
  workflowsLibraryTemplateFromMessage: (id?: string): string =>
    `/workflows/library/templates/new?messageId=${id}`,
  broadcasts: (tab?: MessagingNavTabKey): string => `/broadcasts${tab ? `/${tab}` : ""}`,
  broadcast: (id: string): string => `/broadcasts/${id}`,
  broadcastNew: (): string => "/broadcasts/new",
};

/** This const is auto-generated, as is the whole file */
export const fileSystemTypes = {
  action: {
    name: "Action",
    href: (ref: string) => urls.action(ref),
    listHref: () => urls.actions(),
    filterKey: "action",
    iconType: "action" as FileSystemIconType,
    iconColor: [
      "var(--color-product-actions-light)",
      "var(--color-product-actions-dark)",
    ] as FileSystemIconColor,
  },
  cohort: {
    name: "Cohort",
    iconType: "cohort" as FileSystemIconType,
    iconColor: [
      "var(--color-product-cohorts-light)",
      "var(--color-product-cohorts-dark)",
    ] as FileSystemIconColor,
    href: (ref: string) => urls.cohort(ref),
    listHref: () => urls.cohorts(),
    filterKey: "cohort",
  },
  dashboard: {
    name: "Dashboard",
    iconType: "dashboard" as FileSystemIconType,
    href: (ref: string) => urls.dashboard(ref),
    iconColor: ["var(--color-product-dashboards-light)"],
    filterKey: "dashboard",
  },
  early_access_feature: {
    name: "Early access feature",
    iconType: "early_access_feature" as FileSystemIconType,
    href: (ref: string) => urls.earlyAccessFeature(ref),
    listHref: () => urls.earlyAccessFeatures(),
    iconColor: [
      "var(--color-product-early-access-features-light)",
      "var(--color-product-early-access-features-dark)",
    ],
    filterKey: "early_access_feature",
  },
  endpoints: {
    name: "Endpoints",
    iconType: "endpoints",
    href: () => urls.endpoints(),
    iconColor: ["var(--color-product-endpoints-light)", "var(--color-product-endpoints-dark)"],
    filterKey: "endpoints",
  },
  experiment: {
    name: "Experiment",
    iconType: "experiment",
    href: (ref: string) => urls.experiment(ref),
    listHref: () => urls.experiments(),
    iconColor: ["var(--color-product-experiments-light)"],
    filterKey: "experiment",
  },
  feature_flag: {
    name: "Feature flag",
    iconType: "feature_flag",
    href: (ref: string) => urls.featureFlag(ref),
    listHref: () => urls.featureFlags(),
    iconColor: ["var(--color-product-feature-flags-light)"],
    filterKey: "feature_flag",
  },
  insight: {
    name: "Insight",
    iconType: "product_analytics",
    href: (ref: string) => urls.insightView(ref as InsightShortId),
    listHref: () => urls.savedInsights(),
    iconColor: ["var(--color-product-product-analytics-light)"],
    filterKey: "insight",
  },
  "insight/bi": {
    name: "Worksheet",
    iconType: "business_intelligence",
    href: (ref: string) => urls.businessIntelligenceWorksheet(ref),
    listHref: () => urls.businessIntelligence(),
    filterKey: "insight",
  },
  notebook: {
    name: "Notebook",
    iconType: "notebook",
    href: (ref: string) => urls.notebook(ref),
    filterKey: "notebook",
  },
  product_tour: {
    name: "Product tour",
    iconType: "product_tour",
    href: (ref: string) => urls.productTour(ref),
    listHref: () => urls.productTours(),
    iconColor: [
      "var(--color-product-product-tours-light)",
      "var(--color-product-product-tours-dark)",
    ],
    filterKey: "product_tour",
  },
  session_recording_playlist: {
    name: "Replay playlist",
    iconType: "session_replay",
    href: (ref: string) => urls.replayPlaylist(ref),
    listHref: () => urls.replay(ReplayTabs.Playlists),
    iconColor: [
      "var(--color-product-session-replay-light)",
      "var(--color-product-session-replay-dark)",
    ],
    filterKey: "session_recording_playlist",
  },
  survey: {
    name: "Survey",
    iconType: "survey",
    href: (ref: string) => urls.survey(ref),
    listHref: () => urls.surveys(),
    iconColor: ["var(--color-product-surveys-light)"],
    filterKey: "survey",
  },
  task: {
    name: "Task",
    iconType: "task",
    href: () => urls.taskTracker(),
    iconColor: ["var(--color-product-tasks-light)", "var(--color-product-tasks-dark)"],
    filterKey: "task",
    flag: FEATURE_FLAGS.TASKS,
  },
  workflows: {
    name: "Workflow",
    iconType: "workflows",
    iconColor: ["var(--color-product-workflows-light)"] as FileSystemIconColor,
    href: (ref: string) => urls.workflow(ref, "workflow"),
    listHref: () => urls.workflows(),
    filterKey: "workflows",
  },
};

/** This const is auto-generated, as is the whole file */
export const productSetupProbes: ProductSetupProbe[] = [
  {
    productKey: ProductKey.AI_OBSERVABILITY,
    hasDataEvents: ["$ai_generation", "$ai_trace", "$ai_span", "$ai_embedding"],
    staleAfterDays: 90,
  },
  { productKey: ProductKey.ERROR_TRACKING, hasDataEvents: ["$exception"] },
  {
    productKey: ProductKey.MCP_ANALYTICS,
    hasDataEvents: ["$mcp_tool_call"],
    waitingEvents: ["$mcp_initialize"],
  },
  { productKey: ProductKey.WEB_ANALYTICS, hasDataEvents: ["$web_vitals"] },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsNew = (): FileSystemImport[] => [
  {
    type: "action",
    path: "Action",
    href: urls.createAction(),
    iconType: "action" as FileSystemIconType,
    iconColor: [
      "var(--color-product-actions-light)",
      "var(--color-product-actions-dark)",
    ] as FileSystemIconColor,
  },
  {
    path: `Cohort`,
    type: "cohort",
    href: urls.cohort("new"),
    iconType: "cohort" as FileSystemIconType,
    iconColor: [
      "var(--color-product-cohorts-light)",
      "var(--color-product-cohorts-dark)",
    ] as FileSystemIconColor,
    sceneKeys: ["Cohorts", "Cohort"],
  },
  {
    path: `Dashboard`,
    type: "dashboard",
    href: urls.dashboards() + "#newDashboard=modal",
    iconType: "dashboard" as FileSystemIconType,
    iconColor: ["var(--color-product-dashboards-light)"] as FileSystemIconColor,
    sceneKey: "Dashboard",
    sceneKeys: ["Dashboards", "Dashboard"],
  },
  {
    path: `Data/Destination`,
    type: "hog_function/destination",
    href: urls.dataPipelinesNew("destination"),
    iconColor: [
      "var(--color-product-data-pipeline-light)",
      "var(--color-product-data-pipeline-dark)",
    ],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Data/Source`,
    type: "hog_function/source",
    href: urls.dataPipelinesNew("source"),
    iconColor: [
      "var(--color-product-data-pipeline-light)",
      "var(--color-product-data-pipeline-dark)",
    ],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Data/Transformation`,
    type: "hog_function/transformation",
    href: urls.dataPipelinesNew("transformation"),
    iconColor: [
      "var(--color-product-data-pipeline-light)",
      "var(--color-product-data-pipeline-dark)",
    ],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Data/Web script`,
    type: "hog_function/site_app",
    href: urls.webScriptsNew(),
    iconColor: [
      "var(--color-product-data-pipeline-light)",
      "var(--color-product-data-pipeline-dark)",
    ],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Early access feature`,
    type: "early_access_feature",
    href: urls.earlyAccessFeature("new"),
    iconType: "early_access_feature" as FileSystemIconType,
    iconColor: [
      "var(--color-product-early-access-features-light)",
      "var(--color-product-early-access-features-dark)",
    ] as FileSystemIconColor,
  },
  {
    path: `Experiment`,
    type: "experiment",
    href: urls.experiment("new"),
    iconType: "experiment",
    iconColor: ["var(--color-product-experiments-light)"] as FileSystemIconColor,
    sceneKeys: ["Experiments", "Experiment"],
  },
  {
    path: `Feature flag`,
    type: "feature_flag",
    href: urls.featureFlag("new"),
    iconType: "feature_flag",
    iconColor: ["var(--color-product-feature-flags-light)"] as FileSystemIconColor,
  },
  {
    path: `Insight/Funnel`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.FUNNELS }),
    iconType: "insight/funnels",
    visualOrder: INSIGHT_VISUAL_ORDER.funnel,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Journeys`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.JOURNEYS }),
    flag: FEATURE_FLAGS.PRODUCT_ANALYTICS_PATHS_V2,
    iconType: "insight/paths",
    visualOrder: INSIGHT_VISUAL_ORDER.journeys,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Lifecycle`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.LIFECYCLE }),
    iconType: "insight/lifecycle",
    visualOrder: INSIGHT_VISUAL_ORDER.lifecycle,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Metrics`,
    type: "insight",
    href: urls.insightNew({
      query: {
        kind: NodeKind.MetricsQuery,
        clauses: [],
        dateRange: { date_from: "-1h" },
      } as MetricsQuery,
    }),
    flag: FEATURE_FLAGS.METRICS_INSIGHT_BUILDER,
    iconType: "metrics",
    visualOrder: INSIGHT_VISUAL_ORDER.metrics,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Retention`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.RETENTION }),
    iconType: "insight/retention",
    visualOrder: INSIGHT_VISUAL_ORDER.retention,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/SQL`,
    type: "insight",
    href: urls.sqlEditor({ query: (examples.HogQLForDataVisualization as HogQLQuery).query }),
    displayLabel: "New SQL",
    iconType: "insight/hog",
    visualOrder: INSIGHT_VISUAL_ORDER.sql,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Stickiness`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.STICKINESS }),
    iconType: "insight/stickiness",
    visualOrder: INSIGHT_VISUAL_ORDER.stickiness,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Trends`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.TRENDS }),
    iconType: "insight/trends",
    visualOrder: INSIGHT_VISUAL_ORDER.trends,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/User paths`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.PATHS }),
    iconType: "insight/paths",
    visualOrder: INSIGHT_VISUAL_ORDER.paths,
    sceneKeys: ["Insight"],
  },
  { path: `Notebook`, type: "notebook", href: urls.notebook("new"), iconType: "notebook" },
  {
    path: `Product tour`,
    type: "product_tour",
    href: urls.productTour("new"),
    iconType: "product_tour",
    iconColor: [
      "var(--color-product-product-tours-light)",
      "var(--color-product-product-tours-dark)",
    ] as FileSystemIconColor,
    flag: FEATURE_FLAGS.PRODUCT_TOURS,
  },
  {
    path: `Survey`,
    type: "survey",
    href: urls.surveyWizard("new"),
    iconType: "survey",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
  },
  {
    path: "Worksheet",
    type: "insight",
    iconType: "business_intelligence",
    href: `${urls.businessIntelligenceNew()}#q=`,
    flag: FEATURE_FLAGS.SQL_EDITOR_BI_MODE,
    sceneKeys: ["BusinessIntelligence", "BusinessIntelligenceHome"],
  },
];

/** This const is auto-generated, as is the whole file */
export type ProductTreePath =
  | "Apps"
  | "Autoresearch"
  | "Broadcasts"
  | "Business intelligence"
  | "Business knowledge"
  | "Clusters"
  | "Code review"
  | "Customer analytics"
  | "Dashboards"
  | "Data catalog"
  | "Data warehouse"
  | "Datasets"
  | "Early access features"
  | "Endpoints"
  | "Engineering analytics"
  | "Error tracking"
  | "ETL"
  | "Evaluations"
  | "Experiments"
  | "Feature flags"
  | "Heatmaps"
  | "Identity matching"
  | "Inbox"
  | "LLM analytics"
  | "Logs"
  | "Marketing analytics"
  | "MCP analytics"
  | "MCP servers"
  | "Metrics"
  | "Notebooks"
  | "Playground"
  | "Product analytics"
  | "Product tours"
  | "Prompts"
  | "Pulse"
  | "Replay vision"
  | "Session replay"
  | "Skills"
  | "SQL editor"
  | "Support"
  | "Surveys"
  | "Taggers"
  | "Tasks"
  | "Toolbar"
  | "Tracing"
  | "Visual review"
  | "Web analytics"
  | "Web scripts"
  | "Workflows";

/** This const is auto-generated, as is the whole file */
export const getTreeItemsProducts = (): FileSystemImport[] => [
  {
    path: "Apps",
    intents: [ProductKey.STREAMLIT_APPS],
    href: urls.streamlitApps(),
    searchKeywords: ["python apps", "data apps", "internal tools"],
    type: "streamlit_app",
    category: ProductItemCategory.UNRELEASED,
    flag: FEATURE_FLAGS.STREAMLIT_APPS,
    iconType: "streamlit_app",
    iconColor: [
      "var(--color-product-data-pipeline-light)",
      "var(--color-product-data-pipeline-dark)",
    ],
    sceneKey: "StreamlitApps",
    sceneKeys: ["StreamlitApps", "StreamlitApp", "StreamlitAppEdit"],
  },
  {
    path: "Autoresearch",
    intents: [ProductKey.AUTORESEARCH],
    category: ProductItemCategory.TOOLS,
    type: "autoresearch",
    href: urls.autoresearch(),
    searchKeywords: ["predictions", "churn prediction"],
    flag: FEATURE_FLAGS.AUTORESEARCH,
    iconType: "experiment",
    tags: ["alpha"],
    sceneKey: "Autoresearch",
    sceneKeys: ["Autoresearch", "AutoresearchNew", "AutoresearchPipeline"],
  },
  {
    path: "Broadcasts",
    intents: [ProductKey.WORKFLOWS],
    href: urls.broadcasts(),
    type: "broadcasts",
    category: ProductItemCategory.MESSAGING,
    iconType: "broadcasts",
    iconColor: ["var(--color-product-broadcasts-light)", "var(--color-product-broadcasts-dark)"],
    sceneKey: "Broadcasts",
    sceneKeys: ["Workflows", "Workflow", "WorkflowsLibraryTemplate", "Broadcasts", "Broadcast"],
  },
  {
    path: "Business intelligence",
    intents: [],
    category: ProductItemCategory.DATA,
    iconType: "business_intelligence",
    iconColor: [
      "var(--color-product-business-intelligence-light)",
      "var(--color-product-business-intelligence-dark)",
    ],
    href: urls.businessIntelligence(),
    searchKeywords: ["bi", "pivot table", "chart builder"],
    flag: FEATURE_FLAGS.SQL_EDITOR_BI_MODE,
    sceneKey: "BusinessIntelligence",
    sceneKeys: ["BusinessIntelligenceHome", "BusinessIntelligence"],
  },
  {
    path: "Business knowledge",
    intents: [ProductKey.BUSINESS_KNOWLEDGE],
    category: ProductItemCategory.DATA,
    href: urls.businessKnowledge(),
    searchKeywords: ["knowledge base", "company context"],
    searchTabs: [{ name: "Playground", href: urls.businessKnowledgePlayground() }],
    tags: ["beta"],
    iconType: "business_knowledge",
    iconColor: [
      "var(--color-product-business-knowledge-light)",
      "var(--color-product-business-knowledge-dark)",
    ],
    flag: FEATURE_FLAGS.PRODUCT_BUSINESS_KNOWLEDGE,
    sceneKey: "BusinessKnowledge",
    sceneKeys: [
      "BusinessKnowledge",
      "BusinessKnowledgePlayground",
      "BusinessKnowledgeSettings",
      "BusinessKnowledgeSource",
    ],
  },
  {
    path: "Clusters",
    intents: [ProductKey.LLM_CLUSTERS],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_clusters",
    iconType: "llm_clusters" as FileSystemIconType,
    iconColor: [
      "var(--color-product-llm-clusters-light)",
      "var(--color-product-llm-clusters-dark)",
    ],
    href: urls.aiObservabilityClusters(),
    searchKeywords: ["topics"],
    sceneKey: "AIObservabilityClusters",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityScorers",
      "AIObservabilityScorer",
      "AIObservabilityOfflineExperiments",
      "AIObservabilityOfflineExperiment",
      "AIObservabilityOfflineScorerHistory",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Code review",
    intents: [ProductKey.REVIEW_HOG],
    category: ProductItemCategory.UNRELEASED,
    iconType: "code_review" as FileSystemIconType,
    iconColor: ["var(--color-product-code-review-light)", "var(--color-product-code-review-dark)"],
    href: urls.codeReview(),
    searchKeywords: ["pr review", "review agent", "reviewhog"],
    flag: FEATURE_FLAGS.REVIEW_HOG,
    tags: ["alpha"],
    sceneKey: "CodeReview",
    sceneKeys: ["CodeReview"],
  },
  {
    path: "Customer analytics",
    intents: [ProductKey.CUSTOMER_ANALYTICS],
    category: ProductItemCategory.DATA,
    iconType: "customer_analytics",
    iconColor: [
      "var(--color-product-customer-analytics-light)",
      "var(--color-product-customer-analytics-dark)",
    ] as FileSystemIconColor,
    href: urls.customerAnalytics(),
    searchKeywords: ["crm", "customer success", "account health"],
    searchTabs: [
      {
        name: "Feed",
        href: urls.customerAnalyticsFeed(),
        flag: FEATURE_FLAGS.CUSTOMER_ANALYTICS_CSP,
      },
      {
        name: "Notes",
        href: urls.customerAnalyticsNotes(),
        flag: FEATURE_FLAGS.CUSTOMER_ANALYTICS_CSP,
      },
      {
        name: "Announcements",
        href: urls.customerAnalyticsAnnouncements(),
        flag: FEATURE_FLAGS.CUSTOMER_ANALYTICS_CSP,
      },
      {
        name: "Feature requests",
        href: urls.customerAnalyticsFeatureRequests(),
        flag: FEATURE_FLAGS.CUSTOMER_ANALYTICS_FEATURE_REQUESTS,
      },
      {
        name: "Tasks",
        href: urls.customerAnalyticsTasks(),
        flag: FEATURE_FLAGS.CUSTOMER_ANALYTICS_CUSTOMER_TASKS,
      },
      {
        name: "Customer journeys",
        href: urls.customerAnalyticsJourneys(),
        flag: FEATURE_FLAGS.CUSTOMER_ANALYTICS_JOURNEYS,
      },
    ],
    tags: ["beta"],
    flag: FEATURE_FLAGS.CUSTOMER_ANALYTICS,
    sceneKey: "CustomerAnalytics",
    sceneKeys: [
      "CustomerAnalytics",
      "CustomerAnalyticsAccount",
      "CustomerJourneyTemplates",
      "CustomerJourneyBuilder",
    ],
  },
  {
    path: "Dashboards",
    intents: [ProductKey.PRODUCT_ANALYTICS],
    category: ProductItemCategory.ANALYTICS,
    type: "dashboard",
    iconType: "dashboard",
    iconColor: ["var(--color-product-dashboards-light)"],
    href: urls.dashboards(),
    searchKeywords: ["boards", "charts"],
    searchTabs: [
      { name: "My dashboards", href: urls.dashboards("yours") },
      {
        name: "Cross-project dashboards",
        href: urls.dashboards("cross-project"),
        flag: FEATURE_FLAGS.CROSS_PROJECT_DASHBOARDS,
      },
    ],
    sceneKey: "Dashboards",
    sceneKeys: ["Dashboard", "Dashboards"],
  },
  {
    path: "Data catalog",
    intents: [ProductKey.DATA_CATALOG],
    category: ProductItemCategory.DATA,
    iconType: "data_catalog",
    iconColor: [
      "var(--color-product-data-catalog-light)",
      "var(--color-product-data-catalog-dark)",
    ],
    href: urls.dataCatalog(),
    searchKeywords: ["semantic layer", "metrics", "data dictionary", "glossary", "governance"],
    searchTabs: [
      { name: "Relationships", href: urls.dataCatalog("relationships") },
      { name: "Certifications", href: urls.dataCatalog("certifications") },
    ],
    sceneKey: "DataCatalog",
    sceneKeys: ["DataCatalog", "DataCatalogMetric"],
  },
  {
    path: "Data warehouse",
    displayLabel: "Data ops",
    intents: [ProductKey.DATA_WAREHOUSE, ProductKey.DATA_WAREHOUSE_SAVED_QUERY],
    category: ProductItemCategory.UNRELEASED,
    href: urls.dataOps(),
    searchKeywords: ["managed warehouse", "data lake", "lakehouse"],
    searchTabs: [{ name: "Monitoring", href: urls.dataOps("monitoring") }],
    flag: FEATURE_FLAGS.DATA_WAREHOUSE_SCENE,
    alternativeFlags: [FEATURE_FLAGS.DATA_WAREHOUSE_SCENE_TRINO],
    iconType: "data_warehouse",
    iconColor: ["var(--color-product-data-warehouse-light)"],
    sceneKey: "DataOps",
    sceneKeys: [
      "DataOps",
      "Models",
      "NodeDetail",
      "SQLEditor",
      "Sources",
      "DataWarehouseSource",
      "DataWarehouseSourceNew",
      "DataWarehouseSourceConnect",
      "DataWarehouseSourceSchema",
      "WarehouseDestinations",
    ],
  },
  {
    path: "Datasets",
    intents: [ProductKey.LLM_DATASETS],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_datasets",
    iconType: "llm_datasets" as FileSystemIconType,
    iconColor: [
      "var(--color-product-llm-datasets-light)",
      "var(--color-product-llm-datasets-dark)",
    ],
    href: urls.aiObservabilityDatasets(),
    searchKeywords: ["test sets", "golden set"],
    flag: FEATURE_FLAGS.LLM_ANALYTICS_DATASETS,
    tags: ["beta"],
    sceneKey: "AIObservabilityDatasets",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityScorers",
      "AIObservabilityScorer",
      "AIObservabilityOfflineExperiments",
      "AIObservabilityOfflineExperiment",
      "AIObservabilityOfflineScorerHistory",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "ETL",
    displayLabel: "ELT",
    intents: [ProductKey.DATA_WAREHOUSE],
    category: ProductItemCategory.TOOLS,
    iconType: "data_pipeline",
    iconColor: ["var(--color-product-data-warehouse-light)"],
    href: urls.etlOverview(),
    searchKeywords: ["syncs", "sync health"],
    flag: FEATURE_FLAGS.WAREHOUSE_MULTI_DESTINATION,
    sceneKey: "PipelineOverview",
    sceneKeys: ["PipelineOverview"],
  },
  {
    path: "Early access features",
    intents: [ProductKey.EARLY_ACCESS_FEATURES],
    category: ProductItemCategory.PRODUCT_ENGINEERING,
    type: "early_access_feature",
    href: urls.earlyAccessFeatures(),
    searchKeywords: ["beta", "waitlist", "opt-in"],
    iconType: "early_access_feature" as FileSystemIconType,
    iconColor: [
      "var(--color-product-early-access-features-light)",
      "var(--color-product-early-access-features-dark)",
    ] as FileSystemIconColor,
    sceneKey: "EarlyAccessFeatures",
    sceneKeys: ["EarlyAccessFeatures", "EarlyAccessFeature"],
  },
  {
    path: "Endpoints",
    intents: [ProductKey.ENDPOINTS],
    category: ProductItemCategory.DATA,
    href: urls.endpoints(),
    searchKeywords: ["rest api", "query api"],
    searchTabs: [{ name: "Usage", href: urls.endpointsUsage() }],
    type: "endpoints",
    iconType: "endpoints",
    iconColor: [
      "var(--color-product-endpoints-light)",
      "var(--color-product-endpoints-dark)",
    ] as FileSystemIconColor,
    sceneKey: "EndpointsScene",
    sceneKeys: ["EndpointsScene", "EndpointScene"],
  },
  {
    path: "Engineering analytics",
    intents: [ProductKey.ENGINEERING_ANALYTICS],
    category: ProductItemCategory.UNRELEASED,
    type: "engineering_analytics",
    iconType: "health" as FileSystemIconType,
    iconColor: [
      "var(--color-product-engineering-analytics-light)",
      "var(--color-product-engineering-analytics-dark)",
    ],
    href: urls.engineeringAnalytics(),
    searchKeywords: [
      "ci",
      "ci health",
      "ci cost",
      "github actions",
      "build minutes",
      "dora",
      "cycle time",
    ],
    searchTabs: [
      { name: "Pull requests", href: urls.engineeringAnalyticsPullRequestList() },
      { name: "CI workflows", href: urls.engineeringAnalyticsWorkflows() },
      { name: "Tests", href: urls.engineeringAnalyticsTests(), searchKeywords: ["flaky tests"] },
      { name: "Deploys", href: urls.engineeringAnalyticsDeploys() },
      { name: "Teams", href: urls.engineeringAnalyticsTeams() },
      { name: "Authors", href: urls.engineeringAnalyticsAuthors() },
    ],
    flag: FEATURE_FLAGS.ENGINEERING_ANALYTICS,
    tags: ["alpha"],
    sceneKey: "EngineeringAnalytics",
    sceneKeys: [
      "EngineeringAnalytics",
      "EngineeringAnalyticsPullRequest",
      "EngineeringAnalyticsCIExplorer",
      "EngineeringAnalyticsWorkflowRun",
      "EngineeringAnalyticsWorkflowRuns",
      "EngineeringAnalyticsAuthor",
      "EngineeringAnalyticsTeam",
    ],
  },
  {
    path: "Error tracking",
    intents: [ProductKey.ERROR_TRACKING],
    category: ProductItemCategory.MONITORING,
    type: "error_tracking",
    iconType: "error_tracking" as FileSystemIconType,
    iconColor: [
      "var(--color-product-error-tracking-light)",
      "var(--color-product-error-tracking-dark)",
    ] as FileSystemIconColor,
    href: urls.errorTracking(),
    searchKeywords: ["exceptions", "crashes", "bugs", "stack traces"],
    searchTabs: [
      { name: "Insights", href: urls.errorTracking({ activeTab: "insights" }) },
      {
        name: "Recommendations",
        href: urls.errorTracking({ activeTab: "recommendations" }),
        flag: FEATURE_FLAGS.ERROR_TRACKING_RECOMMENDATIONS,
      },
    ],
    sceneKey: "ErrorTracking",
    sceneKeys: ["ErrorTracking", "ErrorTrackingIssue", "ErrorTrackingFingerprint"],
  },
  {
    path: "Evaluations",
    intents: [ProductKey.LLM_EVALUATIONS],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_evaluations",
    iconType: "llm_evaluations" as FileSystemIconType,
    iconColor: [
      "var(--color-product-llm-evaluations-light)",
      "var(--color-product-llm-evaluations-dark)",
    ],
    href: urls.aiObservabilityEvaluations(),
    searchKeywords: ["llm judge", "llm as a judge", "grading"],
    searchTabs: [
      {
        name: "Offline evals",
        href: urls.aiObservabilityOfflineEvaluations(),
        flag: FEATURE_FLAGS.AI_OBSERVABILITY_OFFLINE_EVALUATIONS,
      },
      { name: "Scorers", href: urls.aiObservabilityScorers() },
    ],
    sceneKey: "AIObservabilityEvaluations",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityScorers",
      "AIObservabilityScorer",
      "AIObservabilityOfflineExperiments",
      "AIObservabilityOfflineExperiment",
      "AIObservabilityOfflineScorerHistory",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: `Experiments`,
    intents: [ProductKey.EXPERIMENTS],
    category: ProductItemCategory.PRODUCT_ENGINEERING,
    type: "experiment",
    href: urls.experiments(),
    searchKeywords: ["a/b testing", "ab test", "split test"],
    searchTabs: [
      { name: "Shared metrics", href: urls.experiments(ExperimentsTabs.SharedMetrics) },
      { name: "Holdout groups", href: urls.experiments(ExperimentsTabs.Holdouts) },
    ],
    iconType: "experiment",
    iconColor: ["var(--color-product-experiments-light)"] as FileSystemIconColor,
    sceneKey: "Experiments",
    sceneKeys: ["Experiments", "Experiment"],
  },
  {
    path: `Feature flags`,
    intents: [ProductKey.FEATURE_FLAGS, ProductKey.EXPERIMENTS, ProductKey.EARLY_ACCESS_FEATURES],
    category: ProductItemCategory.PRODUCT_ENGINEERING,
    type: "feature_flag",
    href: urls.featureFlags(),
    searchKeywords: ["toggles", "rollouts", "remote config", "kill switch"],
    searchTabs: [
      {
        name: "Request usage",
        href: urls.featureFlags("usage"),
        flag: FEATURE_FLAGS.FEATURE_FLAG_REQUEST_USAGE,
      },
      { name: "Projects", href: urls.featureFlags("projects") },
      {
        name: "Notifications",
        href: urls.featureFlags("notifications"),
        flag: FEATURE_FLAGS.FEATURE_FLAG_NOTIFICATIONS,
      },
    ],
    sceneKey: "FeatureFlags",
    sceneKeys: ["FeatureFlags", "FeatureFlag"],
  },
  {
    path: "Heatmaps",
    intents: [ProductKey.HEATMAPS],
    category: ProductItemCategory.PRODUCT_ENGINEERING,
    iconType: "heatmap",
    iconColor: ["var(--color-product-heatmaps-light)", "var(--color-product-heatmaps-dark)"],
    href: urls.heatmaps(),
    searchKeywords: ["clickmaps", "scrollmaps", "scroll depth"],
    sceneKey: "Heatmaps",
    sceneKeys: ["Heatmaps"],
  },
  {
    path: "Identity matching",
    intents: [ProductKey.MARKETING_ANALYTICS],
    category: ProductItemCategory.UNRELEASED,
    href: urls.identityMatching(),
    searchKeywords: ["identity resolution", "deanonymization"],
    flag: FEATURE_FLAGS.IDENTITY_MATCHING,
    tags: ["alpha"],
    iconType: "persons",
    iconColor: [
      "var(--color-product-identity-matching-light)",
      "var(--color-product-identity-matching-dark)",
    ],
    sceneKey: "IdentityMatching",
    sceneKeys: ["IdentityMatching", "AIEnrichment"],
  },
  {
    path: "Inbox",
    displayLabel: "Self-driving inbox",
    intents: [],
    category: ProductItemCategory.TOOLS,
    iconType: "inbox" as FileSystemIconType,
    href: urls.inbox(),
    searchKeywords: ["signals", "triage", "findings"],
    searchTabs: [
      { name: "Reports", href: urls.inbox("reports") },
      { name: "Scouts", href: urls.inbox("scouts") },
    ],
    flag: FEATURE_FLAGS.PRODUCT_AUTONOMY,
    tags: ["beta"],
    sceneKey: "Inbox",
    sceneKeys: ["Inbox"],
  },
  {
    path: "LLM analytics",
    displayLabel: "AI observability",
    intents: [
      ProductKey.AI_OBSERVABILITY,
      ProductKey.LLM_EVALUATIONS,
      ProductKey.LLM_DATASETS,
      ProductKey.LLM_PROMPTS,
      ProductKey.LLM_CLUSTERS,
    ],
    category: ProductItemCategory.AI_ENGINEERING,
    visualOrder: 1,
    type: "llm_analytics",
    iconType: "llm_analytics" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-analytics-light)"] as FileSystemIconColor,
    href: urls.aiObservabilityDashboard(),
    searchKeywords: ["llm observability", "llm costs", "token usage"],
    searchTabs: [
      { name: "Traces", href: urls.aiObservabilityTraces() },
      { name: "Generations", href: urls.aiObservabilityGenerations() },
      { name: "Sessions", href: urls.aiObservabilitySessions() },
      { name: "Users", href: urls.aiObservabilityUsers() },
      { name: "Errors", href: urls.aiObservabilityErrors() },
      { name: "Tools", href: urls.aiObservabilityTools() },
      { name: "Sentiment", href: urls.aiObservabilitySentiment() },
      { name: "Reviews", href: urls.aiObservabilityReviews() },
    ],
    sceneKey: "AIObservability",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityScorers",
      "AIObservabilityScorer",
      "AIObservabilityOfflineExperiments",
      "AIObservabilityOfflineExperiment",
      "AIObservabilityOfflineScorerHistory",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Logs",
    intents: [ProductKey.LOGS],
    category: ProductItemCategory.MONITORING,
    iconType: "logs" as FileSystemIconType,
    iconColor: [
      "var(--color-product-logs-light)",
      "var(--color-product-logs-dark)",
    ] as FileSystemIconColor,
    href: urls.logs(),
    searchTabs: [
      { name: "Alerts", href: urls.logs("alerts") },
      { name: "SQL", href: urls.logs("sql") },
      { name: "Services", href: urls.logs("services"), flag: FEATURE_FLAGS.LOGS_SERVICES_VIEW },
      { name: "Anomalies", href: urls.logs("anomalies"), flag: FEATURE_FLAGS.LOGS_ANOMALIES },
    ],
    sceneKey: "Logs",
    sceneKeys: [
      "Logs",
      "LogsAlertDetail",
      "LogsAlertNotificationDetail",
      "LogsSamplingNew",
      "LogsSamplingDetail",
      "LogsRetentionNew",
      "LogsRetentionDetail",
    ],
  },
  {
    path: "MCP analytics",
    intents: [ProductKey.MCP_ANALYTICS],
    category: ProductItemCategory.AI_ENGINEERING,
    visualOrder: 2,
    type: "mcp_analytics",
    iconType: "mcp_analytics" as FileSystemIconType,
    iconColor: [
      "var(--color-product-mcp-analytics-light)",
      "var(--color-product-mcp-analytics-dark)",
    ],
    href: urls.mcpAnalytics(),
    searchKeywords: ["tool calls", "model context protocol", "plugins"],
    searchTabs: [
      { name: "Activity", href: urls.mcpAnalyticsActivity() },
      { name: "Sessions", href: urls.mcpAnalyticsSessions() },
      { name: "Tool quality", href: urls.mcpAnalyticsToolQuality() },
      { name: "Missing capabilities", href: urls.mcpAnalyticsMissingCapabilities() },
      { name: "Notifications", href: urls.mcpAnalyticsNotifications() },
      {
        name: "Intent clustering",
        href: urls.mcpAnalyticsIntentClustering(),
        flag: FEATURE_FLAGS.MCP_ANALYTICS_INTENT_ROUTING,
      },
    ],
    tags: ["beta"],
    sceneKey: "MCPAnalytics",
    sceneKeys: ["MCPAnalytics", "MCPAnalyticsToolDetail"],
  },
  {
    path: "MCP servers",
    intents: [],
    category: ProductItemCategory.SCHEMA,
    href: urls.mcpGateway(),
    searchKeywords: ["mcp gateway", "tool policies"],
    searchTabs: [{ name: "Audit log", href: urls.mcpGatewayTab("audit") }],
    iconType: "mcp_server",
    iconColor: ["var(--color-product-mcp-servers-light)", "var(--color-product-mcp-servers-dark)"],
    flag: FEATURE_FLAGS.MCP_GATEWAY,
    tags: ["alpha"],
    sceneKey: "McpGateway",
    sceneKeys: ["McpGateway", "McpGatewayServer", "McpGatewayAgent", "McpGatewayMember"],
  },
  {
    path: "Marketing analytics",
    intents: [ProductKey.MARKETING_ANALYTICS],
    category: ProductItemCategory.DATA,
    href: urls.marketingAnalyticsApp(),
    searchKeywords: ["ad spend", "roas", "utm", "attribution", "paid ads"],
    iconType: "marketing_analytics" as FileSystemIconType,
    iconColor: ["var(--color-product-marketing-analytics-light)"] as FileSystemIconColor,
    tags: ["beta"],
    flag: FEATURE_FLAGS.WEB_ANALYTICS_MARKETING,
    sceneKey: "MarketingAnalytics",
    sceneKeys: ["MarketingAnalytics"],
  },
  {
    path: "Metrics",
    intents: [ProductKey.METRICS],
    category: ProductItemCategory.MONITORING,
    iconType: "metrics",
    iconColor: [
      "var(--color-product-metrics-light)",
      "var(--color-product-metrics-dark)",
    ] as FileSystemIconColor,
    href: urls.metrics(),
    searchKeywords: ["time series", "counters", "gauges"],
    searchTabs: [
      { name: "Viewer", href: urls.metrics("viewer") },
      { name: "SQL", href: urls.metrics("sql") },
    ],
    tags: ["alpha"],
    sceneKey: "Metrics",
    sceneKeys: ["Metrics", "MetricsDashboardReview"],
  },
  {
    path: "Notebooks",
    intents: [ProductKey.NOTEBOOKS],
    category: ProductItemCategory.TOOLS,
    type: "notebook",
    iconType: "notebook",
    href: urls.notebooks(),
    searchKeywords: ["documents", "scratchpad"],
    searchTabs: [
      {
        name: "Reusable widgets",
        href: urls.notebooks("widgets"),
        flag: FEATURE_FLAGS.NOTEBOOK_GENERATED_WIDGETS,
      },
    ],
    sceneKey: "Notebooks",
    sceneKeys: ["Notebook", "Notebooks"],
  },
  {
    path: "Playground",
    intents: [ProductKey.AI_OBSERVABILITY],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_playground",
    iconType: "llm_playground" as FileSystemIconType,
    iconColor: [
      "var(--color-product-llm-playground-light)",
      "var(--color-product-llm-playground-dark)",
    ],
    href: urls.aiObservabilityPlayground(),
    searchKeywords: ["prompt testing", "model comparison"],
    sceneKey: "AIObservabilityPlayground",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityScorers",
      "AIObservabilityScorer",
      "AIObservabilityOfflineExperiments",
      "AIObservabilityOfflineExperiment",
      "AIObservabilityOfflineScorerHistory",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Product analytics",
    intents: [ProductKey.PRODUCT_ANALYTICS],
    category: ProductItemCategory.ANALYTICS,
    type: "insight",
    href: urls.insights(),
    searchKeywords: [
      "insights",
      "trends",
      "funnels",
      "retention",
      "paths",
      "journeys",
      "stickiness",
      "lifecycle",
      "calendar heatmap",
      "charts",
    ],
    searchTabs: [
      { name: "My insights", href: urls.savedInsights(SavedInsightsTabs.Yours) },
      { name: "Alerts", href: urls.alerts() },
      { name: "Notifications", href: urls.savedInsights(SavedInsightsTabs.Notifications) },
    ],
    iconType: "product_analytics",
    iconColor: ["var(--color-product-product-analytics-light)"],
    sceneKey: "SavedInsights",
    sceneKeys: ["SavedInsights", "Insight"],
  },
  {
    path: "Product tours",
    intents: [ProductKey.PRODUCT_TOURS],
    category: ProductItemCategory.PRODUCT_ENGINEERING,
    type: "product_tour",
    href: urls.productTours(),
    searchKeywords: ["walkthrough", "onboarding flows", "tooltips"],
    iconType: "product_tour",
    iconColor: [
      "var(--color-product-product-tours-light)",
      "var(--color-product-product-tours-dark)",
    ] as FileSystemIconColor,
    sceneKey: "ProductTours",
    sceneKeys: ["ProductTour", "ProductTours"],
    flag: FEATURE_FLAGS.PRODUCT_TOURS,
  },
  {
    path: "Prompts",
    intents: [ProductKey.LLM_PROMPTS],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_prompts",
    iconType: "llm_prompts" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-prompts-light)", "var(--color-product-llm-prompts-dark)"],
    href: urls.aiObservabilityPrompts(),
    searchKeywords: ["prompt management", "prompt templates"],
    sceneKey: "AIObservabilityPrompts",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityScorers",
      "AIObservabilityScorer",
      "AIObservabilityOfflineExperiments",
      "AIObservabilityOfflineExperiment",
      "AIObservabilityOfflineScorerHistory",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Pulse",
    intents: [ProductKey.PULSE],
    category: ProductItemCategory.UNRELEASED,
    iconType: "pulse",
    iconColor: ["var(--color-product-activity-light)", "var(--color-product-activity-dark)"],
    href: urls.pulse(),
    searchKeywords: ["briefs", "digest"],
    flag: FEATURE_FLAGS.PULSE,
    tags: ["alpha"],
    sceneKey: "Pulse",
    sceneKeys: ["Pulse"],
  },
  {
    path: "Replay vision",
    category: ProductItemCategory.PRODUCT_ENGINEERING,
    intents: [ProductKey.REPLAY_VISION],
    type: "replay_vision",
    iconType: "replay_vision" as FileSystemIconType,
    iconColor: [
      "var(--color-product-session-replay-light)",
      "var(--color-product-session-replay-dark)",
    ] as FileSystemIconColor,
    href: urls.replayVision(),
    searchKeywords: ["scanners", "observations"],
    searchTabs: [
      { name: "Search", href: urls.replayVisionTab("search") },
      { name: "Usage", href: urls.replayVisionTab("usage") },
    ],
    sceneKey: "ReplayVision",
    sceneKeys: ["ReplayVision", "ReplayVisionScanner"],
  },
  {
    path: "SQL editor",
    intents: [ProductKey.DATA_WAREHOUSE_SAVED_QUERY, ProductKey.DATA_WAREHOUSE],
    category: ProductItemCategory.DATA,
    type: "sql",
    iconType: "sql_editor",
    iconColor: ["var(--color-product-data-warehouse-light)"],
    href: urls.sqlEditor(),
    searchKeywords: ["hogql", "hogsql", "query editor"],
    sceneKey: "SQLEditor",
    sceneKeys: ["SQLEditor"],
  },
  {
    path: "Session replay",
    intents: [ProductKey.SESSION_REPLAY, ProductKey.MOBILE_REPLAY],
    category: ProductItemCategory.PRODUCT_ENGINEERING,
    href: urls.replay(ReplayTabs.Home),
    searchKeywords: ["recordings", "session recording"],
    searchTabs: [
      {
        name: "Collections",
        href: urls.replay(ReplayTabs.Playlists),
        searchKeywords: ["playlists"],
      },
    ],
    type: "session_recording_playlist",
    iconType: "session_replay",
    iconColor: [
      "var(--color-product-session-replay-light)",
      "var(--color-product-session-replay-dark)",
    ],
    sceneKey: "Replay",
    sceneKeys: [
      "Replay",
      "ReplaySingle",
      "ReplaySettings",
      "ReplayPlaylist",
      "ReplayFilePlayback",
      "ReplayKiosk",
    ],
  },
  {
    path: "Skills",
    intents: [ProductKey.SKILLS],
    category: ProductItemCategory.TOOLS,
    type: "llm_skills",
    iconType: "skill",
    iconColor: ["var(--color-product-skills-light)", "var(--color-product-skills-dark)"],
    href: urls.skills(),
    searchKeywords: ["agent instructions", "playbooks"],
    searchTabs: [
      { name: "Scouts", href: urls.skillsCategoryTab("scouts") },
      {
        name: "Community",
        href: urls.communitySkills(),
        flag: FEATURE_FLAGS.LLM_ANALYTICS_COMMUNITY_SKILLS,
      },
    ],
    sceneKey: "Skills",
    sceneKeys: ["Skills", "Skill", "CommunitySkills"],
  },
  {
    path: "Support",
    intents: [ProductKey.CONVERSATIONS],
    category: ProductItemCategory.MONITORING,
    href: urls.supportTickets(),
    searchKeywords: ["tickets", "conversations", "helpdesk", "chat widget"],
    type: "conversations",
    iconType: "conversations",
    iconColor: [
      "var(--color-product-support-light)",
      "var(--color-product-support-dark)",
    ] as FileSystemIconColor,
    sceneKey: "SupportTickets",
    sceneKeys: ["SupportTickets", "SupportTicketDetail", "SupportSettings", "MyTickets"],
  },
  {
    path: "Surveys",
    intents: [ProductKey.SURVEYS],
    category: ProductItemCategory.PRODUCT_ENGINEERING,
    type: "survey",
    href: urls.surveys(),
    searchKeywords: ["feedback", "nps", "csat", "polls"],
    searchTabs: [{ name: "Notifications", href: urls.surveys("notifications") }],
    iconType: "survey",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
    sceneKey: "Surveys",
    sceneKeys: ["Survey", "Surveys"],
  },
  {
    path: "Taggers",
    intents: [ProductKey.AI_OBSERVABILITY],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_tags",
    iconType: "llm_tags" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-tags-light)", "var(--color-product-llm-tags-dark)"],
    href: urls.aiObservabilityTags(),
    searchKeywords: ["llm tags", "auto-tagging"],
    flag: FEATURE_FLAGS.LLM_ANALYTICS_TAGS,
    tags: ["alpha"],
    sceneKey: "AIObservabilityTags",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityScorers",
      "AIObservabilityScorer",
      "AIObservabilityOfflineExperiments",
      "AIObservabilityOfflineExperiment",
      "AIObservabilityOfflineScorerHistory",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Tasks",
    intents: [ProductKey.TASKS],
    category: ProductItemCategory.TOOLS,
    type: "task",
    iconType: "task",
    iconColor: ["var(--color-product-tasks-light)", "var(--color-product-tasks-dark)"],
    href: urls.taskTracker(),
    searchKeywords: ["coding agent", "background agent"],
    sceneKey: "TaskTracker",
    flag: FEATURE_FLAGS.TASKS,
    sceneKeys: ["TaskTracker"],
  },
  {
    path: "Toolbar",
    intents: [ProductKey.TOOLBAR],
    href: urls.toolbarLaunch(),
    searchKeywords: ["authorized urls", "inspect element"],
    type: "toolbar",
    category: ProductItemCategory.TOOLS,
    iconType: "toolbar",
    iconColor: ["var(--color-product-toolbar-light)", "var(--color-product-toolbar-dark)"],
    sceneKey: "Toolbar",
    sceneKeys: ["Toolbar"],
  },
  {
    path: "Tracing",
    intents: [ProductKey.TRACING],
    category: ProductItemCategory.MONITORING,
    iconType: "tracing",
    iconColor: [
      "var(--color-product-tracing-light)",
      "var(--color-product-tracing-dark)",
    ] as FileSystemIconColor,
    href: urls.tracing(),
    searchKeywords: ["apm", "spans", "latency"],
    searchTabs: [
      { name: "SQL", href: urls.tracing("sql"), flag: FEATURE_FLAGS.TRACING_SCENE_TABS },
    ],
    flag: FEATURE_FLAGS.TRACING,
    sceneKey: "Tracing",
    sceneKeys: ["Tracing", "TracingOperation", "TracingRetentionNew", "TracingRetentionDetail"],
  },
  {
    path: "Visual review",
    intents: [ProductKey.VISUAL_REVIEW],
    category: ProductItemCategory.UNRELEASED,
    href: urls.visualReviewRuns(),
    searchKeywords: ["visual regression", "screenshot diffs", "baselines"],
    iconType: "visual_review" as FileSystemIconType,
    iconColor: [
      "var(--color-product-visual-review-light)",
      "var(--color-product-visual-review-dark)",
    ] as FileSystemIconColor,
    flag: FEATURE_FLAGS.VISUAL_REVIEW,
    tags: ["alpha"],
    sceneKey: "VisualReviewIndex",
    sceneKeys: [
      "VisualReviewIndex",
      "VisualReviewRuns",
      "VisualReviewRun",
      "VisualReviewSettings",
      "VisualReviewSnapshotHistory",
      "VisualReviewSnapshotOverview",
      "VisualReviewFlakiness",
    ],
  },
  {
    path: "Web analytics",
    intents: [ProductKey.WEB_ANALYTICS],
    category: ProductItemCategory.ANALYTICS,
    iconType: "web_analytics",
    iconColor: ["var(--color-product-web-analytics-light)"] as FileSystemIconColor,
    href: urls.webAnalytics(),
    searchKeywords: ["traffic", "pageviews", "visitors", "bounce rate", "referrers"],
    searchTabs: [
      { name: "Web vitals", href: urls.webAnalyticsWebVitals() },
      { name: "Page reports", href: urls.webAnalyticsPageReports() },
      { name: "Live", href: urls.webAnalyticsLive() },
      { name: "Installation health", href: urls.webAnalyticsHealth() },
      {
        name: "Bots",
        href: urls.webAnalyticsBotAnalytics(),
        flag: FEATURE_FLAGS.WEB_ANALYTICS_BOT_ANALYSIS,
      },
      {
        name: "Search & AI",
        href: urls.webAnalyticsPagePerformance(),
        flag: FEATURE_FLAGS.WEB_ANALYTICS_PAGE_PERFORMANCE,
      },
      {
        name: "Agents",
        href: urls.webAnalyticsAgents(),
        flag: FEATURE_FLAGS.WEB_ANALYTICS_AGENT_ANALYTICS,
      },
    ],
    sceneKey: "WebAnalytics",
    sceneKeys: ["WebAnalytics"],
  },
  {
    path: "Web scripts",
    intents: [ProductKey.SITE_APPS],
    category: ProductItemCategory.TOOLS,
    type: "hog_function",
    iconType: "web_script",
    iconColor: ["var(--color-product-web-scripts-light)", "var(--color-product-web-scripts-dark)"],
    href: urls.webScripts(),
    searchKeywords: ["site apps", "custom javascript", "tag manager"],
    sceneKey: "WebScripts",
    sceneKeys: ["WebScripts"],
  },
  {
    path: "Workflows",
    intents: [ProductKey.WORKFLOWS],
    href: urls.workflows(),
    searchTabs: [
      { name: "Library", href: urls.workflows("library") },
      { name: "Channels", href: urls.workflows("channels") },
      { name: "Opt-outs", href: urls.workflows("opt-outs") },
      { name: "Suppression list", href: urls.workflows("suppression") },
      { name: "Reputation", href: urls.workflows("reputation") },
    ],
    type: "workflows",
    category: ProductItemCategory.MESSAGING,
    iconType: "workflows",
    iconColor: ["var(--color-product-workflows-light)"] as FileSystemIconColor,
    sceneKey: "Workflows",
    sceneKeys: ["Workflows", "Workflow", "WorkflowsLibraryTemplate", "Broadcasts", "Broadcast"],
  },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsGames = (): FileSystemImport[] => [
  { path: "368 Hedgehogs", href: urls.game368hedgehogs() },
  { path: "Flappy Hog", href: "/games/flappyhog" },
  { path: "Ship It", href: urls.shipIt() },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsMetadata = (): FileSystemImport[] => [
  {
    path: "Actions",
    category: "Schema",
    href: urls.actions(),
    searchKeywords: ["event group", "grouped events"],
    iconType: "action" as FileSystemIconType,
    sceneKey: "Actions",
    sceneKeys: ["Actions", "Action", "NewAction"],
  },
  {
    path: "Annotations",
    category: "Schema",
    iconType: "annotation",
    iconColor: ["var(--color-product-annotations-light)", "var(--color-product-annotations-dark)"],
    href: urls.annotations(),
    searchKeywords: ["markers", "releases"],
    sceneKey: "Annotations",
    sceneKeys: ["Annotations"],
  },
  {
    path: "Core events",
    category: "Schema",
    iconType: "core_event",
    iconColor: ["var(--color-product-core-events-light)", "var(--color-product-core-events-dark)"],
    href: urls.coreEvents(),
    searchKeywords: ["key events", "conversion events"],
    flag: FEATURE_FLAGS.NEW_TEAM_CORE_EVENTS,
    sceneKeys: [],
  },
  {
    path: `Destinations`,
    category: "CDP",
    type: "hog_function/destination",
    iconType: "data_destination",
    iconColor: [
      "var(--color-product-destinations-light)",
      "var(--color-product-destinations-dark)",
    ],
    href: urls.destinations(),
    searchKeywords: ["export data", "webhooks"],
    searchTabs: [
      {
        name: "Batch exports",
        href: urls.destinations("batch"),
        searchKeywords: ["scheduled export"],
      },
    ],
    sceneKey: "Destinations",
    sceneKeys: ["Destinations"],
  },
  {
    path: "Endpoints",
    category: "Data",
    iconType: "endpoints" as FileSystemIconType,
    iconColor: [
      "var(--color-product-endpoints-light)",
      "var(--color-product-endpoints-dark)",
    ] as FileSystemIconColor,
    href: urls.endpoints(),
    sceneKey: "EndpointsScene",
    sceneKeys: ["EndpointsScene", "EndpointScene"],
  },
  {
    path: "Event definitions",
    category: "Schema",
    iconType: "event_definition",
    iconColor: [
      "var(--color-product-event-definitions-light)",
      "var(--color-product-event-definitions-dark)",
    ],
    href: urls.eventDefinitions(),
    searchKeywords: ["taxonomy", "tracking plan"],
    sceneKey: "EventDefinitions",
    sceneKeys: ["EventDefinition", "EventDefinitions"],
  },
  {
    path: "Event ingestion filtering",
    category: "CDP",
    type: "event_filter",
    iconType: "event_filter",
    iconColor: [
      "var(--color-product-event-filtering-light)",
      "var(--color-product-event-filtering-dark)",
    ],
    href: urls.eventFiltering(),
    searchKeywords: ["drop events", "block events"],
    sceneKey: "EventFiltering",
    sceneKeys: ["EventFiltering"],
  },
  {
    path: "Managed migrations",
    category: "CDP",
    iconType: "managed_migration",
    iconColor: [
      "var(--color-product-managed-migrations-light)",
      "var(--color-product-managed-migrations-dark)",
    ],
    href: urls.managedMigration(),
    searchKeywords: ["historical import", "backfill"],
    sceneKey: "ManagedMigration",
    sceneKeys: ["ManagedMigration", "ManagedMigrationNew"],
  },
  {
    path: "Managed viewsets",
    category: "Unreleased",
    iconType: "managed_viewsets",
    iconColor: [
      "var(--color-product-managed-viewsets-light)",
      "var(--color-product-managed-viewsets-dark)",
    ],
    href: urls.dataWarehouseManagedViewsets(),
    flag: FEATURE_FLAGS.MANAGED_VIEWSETS,
    sceneKeys: [
      "DataOps",
      "Models",
      "NodeDetail",
      "SQLEditor",
      "Sources",
      "DataWarehouseSource",
      "DataWarehouseSourceNew",
      "DataWarehouseSourceConnect",
      "DataWarehouseSourceSchema",
      "WarehouseDestinations",
    ],
  },
  {
    path: "Models",
    category: "Data",
    type: "sql",
    iconType: "data_modeling",
    iconColor: ["var(--color-product-models-light)", "var(--color-product-models-dark)"],
    href: urls.models(),
    searchKeywords: [
      "materialized views",
      "materialization",
      "data modeling",
      "sql views",
      "saved queries",
    ],
    searchTabs: [
      { name: "Lineage", href: urls.models("lineage"), searchKeywords: ["dag", "dependencies"] },
      {
        name: "Data quality",
        href: urls.models("data-quality"),
        flag: FEATURE_FLAGS.DATA_QUALITY_CHECKS,
        searchKeywords: ["tests", "checks", "freshness"],
      },
    ],
    sceneKey: "Models",
    sceneKeys: ["Models"],
  },
  {
    path: "Property definitions",
    category: "Schema",
    iconType: "property_definition",
    iconColor: [
      "var(--color-product-property-definitions-light)",
      "var(--color-product-property-definitions-dark)",
    ],
    href: urls.propertyDefinitions(),
    searchKeywords: ["attributes", "traits"],
    sceneKey: "PropertyDefinitions",
    sceneKeys: ["PropertyDefinition", "PropertyDefinitions"],
  },
  {
    path: "Property groups",
    category: "Schema",
    iconType: "property_group",
    iconColor: [
      "var(--color-product-property-groups-light)",
      "var(--color-product-property-groups-dark)",
    ],
    href: urls.schemaManagement(),
    searchKeywords: ["property schema"],
    flag: FEATURE_FLAGS.SCHEMA_MANAGEMENT,
    sceneKeys: [],
  },
  {
    path: "Revenue definitions",
    category: "Schema",
    iconType: "revenue_analytics_metadata" as FileSystemIconType,
    iconColor: [
      "var(--color-product-revenue-analytics-light)",
      "var(--color-product-revenue-analytics-dark)",
    ],
    href: urls.revenueSettings(),
    searchKeywords: ["currency", "mrr"],
    sceneKey: "DataManagement",
    sceneKeys: [],
  },
  {
    path: "SQL variables",
    category: "Schema",
    iconType: "sql_variable",
    iconColor: [
      "var(--color-product-sql-variables-light)",
      "var(--color-product-sql-variables-dark)",
    ],
    href: urls.variables(),
    searchKeywords: ["parameters", "placeholders"],
    sceneKeys: ["SqlVariableEdit"],
  },
  {
    path: `Sources`,
    category: "CDP",
    type: "hog_function/source",
    iconType: "data_source",
    iconColor: ["var(--color-product-sources-light)", "var(--color-product-sources-dark)"],
    href: urls.sources(),
    searchKeywords: [
      "data warehouse",
      "warehouse",
      "connectors",
      "import data",
      "external data",
      "inbound webhooks",
    ],
    sceneKey: "Sources",
    sceneKeys: ["Sources"],
  },
  {
    path: `Transformations`,
    category: "CDP",
    type: "hog_function/transformation",
    iconType: "data_transformation",
    iconColor: [
      "var(--color-product-transformations-light)",
      "var(--color-product-transformations-dark)",
    ],
    href: urls.transformations(),
    searchKeywords: ["enrichment", "geoip", "redact pii"],
    sceneKey: "Transformations",
    sceneKeys: ["Transformations"],
  },
  {
    path: "Warehouse destinations",
    category: "CDP",
    iconType: "warehouse_destination",
    iconColor: [
      "var(--color-product-warehouse-destinations-light)",
      "var(--color-product-warehouse-destinations-dark)",
    ],
    href: urls.warehouseDestinations(),
    flag: FEATURE_FLAGS.WAREHOUSE_MULTI_DESTINATION,
    sceneKey: "WarehouseDestinations",
    sceneKeys: ["WarehouseDestinations"],
  },
  {
    path: "Warehouse properties",
    category: "Schema",
    iconType: "warehouse_property",
    iconColor: [
      "var(--color-product-warehouse-properties-light)",
      "var(--color-product-warehouse-properties-dark)",
    ],
    href: urls.warehouseProperties(),
    searchKeywords: ["crm properties", "joined properties"],
    flag: FEATURE_FLAGS.WAREHOUSE_PERSON_PROPERTIES,
    sceneKey: "WarehouseProperties",
    sceneKeys: ["WarehouseProperties"],
  },
];
